var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinibus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 863.34 313.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.4;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109{stroke-width:0px;}.cls-1,.cls-24,.cls-28,.cls-74,.cls-75,.cls-76,.cls-79,.cls-83,.cls-85,.cls-88,.cls-93,.cls-108{fill:#000;}.cls-2{fill:#db8189;}.cls-3{fill:url(#linear-gradient-42);}.cls-3,.cls-92,.cls-93{opacity:.5;}.cls-4{fill:url(#New_Gradient_Swatch_8);}.cls-5{fill:url(#New_Gradient_Swatch_7);}.cls-110{mask:url(#mask-15);}.cls-111{mask:url(#mask-17);}.cls-112{mask:url(#mask-18);}.cls-113{mask:url(#mask-14);}.cls-114{mask:url(#mask-13);}.cls-115{mask:url(#mask-19);}.cls-116{mask:url(#mask-12);}.cls-117{mask:url(#mask-11);}.cls-118{mask:url(#mask-16);}.cls-119{mask:url(#mask-10);}.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-25,.cls-74,.cls-120,.cls-78,.cls-86,.cls-87{mix-blend-mode:multiply;}.cls-6,.cls-105{fill:#b8b9bb;}.cls-121{filter:url(#luminosity-noclip-9);}.cls-122{filter:url(#luminosity-noclip-7);}.cls-123{filter:url(#luminosity-noclip-3);}.cls-124{filter:url(#luminosity-noclip-5);}.cls-7{fill:url(#linear-gradient-13);}.cls-8{fill:url(#linear-gradient-14);}.cls-9{fill:url(#linear-gradient-15);}.cls-10{fill:url(#linear-gradient-16);}.cls-11{fill:url(#linear-gradient-68);}.cls-12{fill:url(#linear-gradient-66);}.cls-13{fill:url(#linear-gradient-64);}.cls-14{fill:url(#linear-gradient-60);}.cls-15{fill:url(#linear-gradient-62);}.cls-16{fill:url(#linear-gradient-70);}.cls-17{fill:url(#linear-gradient-51);}.cls-18{fill:url(#linear-gradient-54);}.cls-19{fill:url(#linear-gradient-58);}.cls-20{fill:url(#linear-gradient-41);}.cls-21{fill:url(#linear-gradient-46);}.cls-22{fill:url(#New_Gradient_Swatch_8-2);}.cls-23{fill:url(#New_Gradient_Swatch_7-2);}.cls-125{mask:url(#mask);}.cls-24{opacity:.9;}.cls-25,.cls-106{fill:#e6e7e7;}.cls-26{fill:url(#linear-gradient);}.cls-126{filter:url(#luminosity-noclip);}.cls-27{fill:#cc4d59;}.cls-28{opacity:.2;}.cls-29{fill:url(#linear-gradient-38);}.cls-30{fill:url(#linear-gradient-33);}.cls-31{fill:url(#linear-gradient-29);}.cls-32{fill:url(#linear-gradient-32);}.cls-33{fill:url(#linear-gradient-30);}.cls-34{fill:url(#linear-gradient-31);}.cls-35{fill:url(#linear-gradient-36);}.cls-36{fill:url(#linear-gradient-39);}.cls-37{fill:url(#linear-gradient-34);}.cls-38{fill:url(#linear-gradient-37);}.cls-39{fill:url(#linear-gradient-35);}.cls-40{fill:url(#linear-gradient-28);}.cls-41{fill:url(#linear-gradient-25);}.cls-42{fill:url(#linear-gradient-11);}.cls-43{fill:url(#linear-gradient-12);}.cls-44{fill:url(#linear-gradient-10);}.cls-45{fill:url(#linear-gradient-17);}.cls-46{fill:url(#linear-gradient-19);}.cls-47{fill:url(#linear-gradient-23);}.cls-48{fill:url(#linear-gradient-21);}.cls-49{fill:url(#linear-gradient-18);}.cls-50{fill:url(#linear-gradient-22);}.cls-51{fill:url(#linear-gradient-20);}.cls-52{fill:url(#linear-gradient-27);}.cls-53{fill:url(#linear-gradient-24);}.cls-54{fill:url(#linear-gradient-26);}.cls-55{fill:url(#linear-gradient-45);}.cls-56{fill:url(#linear-gradient-44);}.cls-57{fill:url(#linear-gradient-48);}.cls-58{fill:url(#linear-gradient-49);}.cls-59{fill:url(#linear-gradient-47);}.cls-60{fill:url(#linear-gradient-43);}.cls-61{fill:url(#linear-gradient-40);}.cls-62{fill:url(#linear-gradient-59);}.cls-63{fill:url(#linear-gradient-57);}.cls-64{fill:url(#linear-gradient-55);}.cls-65{fill:url(#linear-gradient-56);}.cls-66{fill:url(#linear-gradient-53);}.cls-67{fill:url(#linear-gradient-52);}.cls-68{fill:url(#linear-gradient-50);}.cls-69{fill:url(#linear-gradient-61);}.cls-70{fill:url(#linear-gradient-65);}.cls-71{fill:url(#linear-gradient-67);}.cls-72{fill:url(#linear-gradient-69);}.cls-73{fill:url(#linear-gradient-71);}.cls-127{filter:url(#luminosity-noclip-17);}.cls-128{filter:url(#luminosity-noclip-15);}.cls-129{filter:url(#luminosity-noclip-19);}.cls-130{filter:url(#luminosity-noclip-13);}.cls-131{filter:url(#luminosity-noclip-11);}.cls-75{opacity:0;}.cls-76,.cls-90,.cls-132{opacity:.7;}.cls-77,.cls-86{fill:#dadbdc;}.cls-78{fill:#c3c4c5;}.cls-79{opacity:.8;}.cls-80{fill:#f7f8f8;}.cls-81{fill:url(#New_Gradient_Swatch_11-2);}.cls-82{fill:#cecfd1;}.cls-84{fill:#adaeb1;}.cls-85{opacity:.1;}.cls-87{fill:#418752;}.cls-88{opacity:.6;}.cls-89{fill:#a1a3a5;}.cls-90{fill:url(#linear-gradient-63);}.cls-91{fill:#fbc380;}.cls-92,.cls-107{fill:#fff;}.cls-94{fill:url(#linear-gradient-4);}.cls-95{fill:url(#linear-gradient-2);}.cls-96{fill:url(#linear-gradient-3);}.cls-97{fill:url(#linear-gradient-8);}.cls-98{fill:url(#linear-gradient-9);}.cls-99{fill:url(#linear-gradient-7);}.cls-100{fill:url(#linear-gradient-5);}.cls-101{fill:url(#linear-gradient-6);}.cls-102{fill:#d6717b;}.cls-103{fill:url(#New_Gradient_Swatch_11);}.cls-104{fill:#939598;}.cls-133{isolation:isolate;}.cls-108{opacity:.3;}.cls-134{mask:url(#mask-3);}.cls-135{mask:url(#mask-2);}.cls-136{mask:url(#mask-5);}.cls-137{mask:url(#mask-4);}.cls-138{mask:url(#mask-1);}.cls-139{mask:url(#mask-7);}.cls-140{mask:url(#mask-6);}.cls-141{mask:url(#mask-8);}.cls-142{mask:url(#mask-9);}.cls-109{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11",
    x1: 152.26,
    y1: 313.73,
    x2: 152.26,
    y2: 227.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adaeb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_7",
    x1: 152.26,
    y1: 235.2,
    x2: 152.26,
    y2: 308.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1a3a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 152.26,
    y1: 297.46,
    x2: 152.26,
    y2: 244.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cecfd1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 152.26,
    y1: 246.83,
    x2: 152.26,
    y2: 295.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 247.3,
    y2: 293.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 284.34,
    y2: 256.76,
    gradientTransform: "translate(6.81 -3.72) rotate(1.43)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 152.26,
    y1: 263.08,
    x2: 152.26,
    y2: 279.02,
    gradientTransform: "translate(10.5 -5.64) rotate(2.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adaeb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 275.65,
    y2: 265.85,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11-2",
    x1: 634.95,
    x2: 634.95,
    xlinkHref: "#New_Gradient_Swatch_11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_7-2",
    x1: 634.96,
    x2: 634.96,
    xlinkHref: "#New_Gradient_Swatch_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 634.96,
    x2: 634.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 634.96,
    x2: 634.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 634.96,
    y1: 247.21,
    x2: 634.96,
    y2: 293.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1a3a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 634.96,
    y1: 279.18,
    x2: 634.96,
    y2: 261.96,
    gradientTransform: "translate(14.27 -31.29) rotate(2.86)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 634.96,
    y1: 276.92,
    x2: 634.96,
    y2: 264.62,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 437.9,
    y1: 218.74,
    x2: 437.9,
    y2: 54.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#afb0b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#bdbfc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c4c5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 271.26,
    y: 236.9,
    width: 111.68,
    height: 18.01,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 271.26,
    y: -10496.69,
    width: 111.68,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 271.26,
    y: -10496.69,
    width: 111.68,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3.29,
    y1: 1733.64,
    x2: 3.29,
    y2: 1715.05,
    gradientTransform: "translate(323.81 -1478.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 271.26,
    y: 236.9,
    width: 111.68,
    height: 18.01,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 271.26,
    y: 236.9,
    width: 111.68,
    height: 18.01,
    transform: "translate(654.2 491.81) rotate(180)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3.29,
    y1: 1733.64,
    x2: 3.29,
    y2: 1715.05,
    gradientTransform: "translate(323.81 -1478.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e7e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#c7c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#b4b4b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adaeb1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 271.26,
    y: 226.45,
    width: 111.68,
    height: 7.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 271.26,
    y: -10496.69,
    width: 111.68,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 271.26,
    y: -10496.69,
    width: 111.68,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -6894.4,
    y1: -4799.73,
    x2: -6894.4,
    y2: -4807.78,
    gradientTransform: "translate(7221.5 5034.06)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 271.26,
    y: 226.45,
    width: 111.68,
    height: 7.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 271.26,
    y: 226.45,
    width: 111.68,
    height: 7.8
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -6894.4,
    y1: -4799.73,
    x2: -6894.4,
    y2: -4807.78,
    gradientTransform: "translate(7221.5 5034.06)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 443.88,
    y1: 254.91,
    x2: 443.88,
    y2: 49.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cecfd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#cacbce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c0c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b0b0bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9898ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7a7899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#555281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#292664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262262"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 128.18,
    y1: 0.31,
    x2: 128.18,
    y2: 16.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbc380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db8189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 128.18,
    y1: 2.42,
    x2: 128.18,
    y2: 13.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db8189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_8",
    x1: 120.31,
    y1: 14.98,
    x2: 135.96,
    y2: 14.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 128.18,
    y1: 15.86,
    x2: 128.18,
    y2: 21.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b15a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 128.18,
    y1: 20.91,
    x2: 128.18,
    y2: 22.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1a3a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#828485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4a4b4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#222223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 20.31,
    y2: 39.51,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 805,
    x2: 805,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 805,
    x2: 805,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_8-2",
    x1: 797.13,
    x2: 812.78,
    xlinkHref: "#New_Gradient_Swatch_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 805,
    x2: 805,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 805,
    x2: 805,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 805,
    y1: 20.31,
    x2: 805,
    y2: 39.51,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 439.43,
    y1: 277.93,
    x2: 439.43,
    y2: 19.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f8f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 439.43,
    y1: 197.87,
    x2: 439.43,
    y2: 277.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ebecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadbdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 299.5,
    y1: 268,
    x2: 299.5,
    y2: 57.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#eaebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#dadbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#eaebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 354.7,
    x2: 354.7,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 851.93,
    y1: 238.52,
    x2: 851.93,
    y2: 215.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc4d59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 19.23,
    y1: 244.69,
    x2: 19.23,
    y2: 215.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 36.22,
    y1: 244.69,
    x2: 36.22,
    y2: 215.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 40.57,
    y1: 244.27,
    x2: 40.57,
    y2: 216.38,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 45.19,
    y1: 221.7,
    x2: 45.19,
    y2: 216.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ececed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dfdfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b9bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 21.37,
    y1: 231.3,
    x2: 21.37,
    y2: 219.04,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 22.02,
    y1: 240.97,
    x2: 22.02,
    y2: 233.03,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 7393.75,
    y1: 237.35,
    x2: 7393.75,
    y2: 216.38,
    gradientTransform: "translate(8244.48) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc4d59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 7398.45,
    y1: 221.7,
    x2: 7398.45,
    y2: 216.38,
    gradientTransform: "translate(-6552.42 438.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 109.14,
    y: 21.28,
    width: 712.65,
    height: 19.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 109.14,
    y: -10496.69,
    width: 712.65,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 109.14,
    y: -10496.69,
    width: 712.65,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 465.46,
    y1: 40.68,
    x2: 465.46,
    y2: 21.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 109.14,
    y: 21.28,
    width: 712.65,
    height: 19.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M109.14,21.28h712.65c0,10.71-8.69,19.4-19.4,19.4H128.54c-10.71,0-19.4-8.69-19.4-19.4h0Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 465.46,
    y1: 40.68,
    x2: 465.46,
    y2: 21.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 233.09,
    y1: 257.93,
    x2: 233.09,
    y2: 264.32,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 487.62,
    y1: 257.93,
    x2: 487.62,
    y2: 264.32,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 760.02,
    y1: 257.93,
    x2: 760.02,
    y2: 264.32,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 327.1,
    y1: 274.33,
    x2: 327.1,
    y2: 268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f4f5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1a3a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 857.81,
    y1: 216.13,
    x2: 857.81,
    y2: 227.03,
    gradientTransform: "translate(1715.63 443) rotate(-180)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 2444.95,
    y1: 4867.5,
    x2: 2444.95,
    y2: 4877.56,
    gradientTransform: "translate(-1587.32 -4639.84)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 13.19,
    y1: 124.77,
    x2: 19.35,
    y2: 142.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8c8aac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8d8bad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9492b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#a09eba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#b0afc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c6c5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e0dfe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c6c5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9c9ab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8c8aac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#a28c8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#db9141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f7941d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 9.39,
    y1: 82.73,
    x2: 9.39,
    y2: 125.2,
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 20.68,
    y1: 106.89,
    x2: 59.01,
    y2: 106.89,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 233.09,
    y1: 37.57,
    x2: 233.09,
    y2: 43.96,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 760.02,
    y1: 37.57,
    x2: 760.02,
    y2: 43.96,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 6682.36,
    y1: 379.59,
    x2: 6701.57,
    y2: 379.59,
    gradientTransform: "translate(-61.44 6868.8) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cecfd1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 6682.36,
    y1: 377.91,
    x2: 6682.36,
    y2: 381.42,
    gradientTransform: "translate(-61.44 6868.8) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 6700.84,
    x2: 6700.84,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 6691.6,
    y1: 378.38,
    x2: 6691.6,
    y2: 380.91,
    gradientTransform: "translate(-6373.45 -202.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cecfd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 281.41,
    y: 82.4,
    width: 35.54,
    height: 54.23,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 281.41,
    y: -10496.69,
    width: 35.54,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 281.41,
    y: -10496.69,
    width: 35.54,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 299.18,
    y1: 136.63,
    x2: 299.18,
    y2: 82.4,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 281.41,
    y: 82.4,
    width: 35.54,
    height: 54.23,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M286.64,136.63h0c-2.89,0-5.23-2.34-5.23-5.23v-43.76c0-2.89,2.34-5.23,5.23-5.23h25.07c2.89,0,5.23,2.34,5.23,5.23v18.69c0,16.74-13.57,30.3-30.3,30.3Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 299.18,
    y1: 136.63,
    x2: 299.18,
    y2: 82.4,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 337.25,
    y: 82.4,
    width: 35.54,
    height: 54.23,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 337.25,
    y: -10496.69,
    width: 35.54,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 337.25,
    y: -10496.69,
    width: 35.54,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 355.02,
    y1: 136.63,
    x2: 355.02,
    y2: 82.4,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 337.25,
    y: 82.4,
    width: 35.54,
    height: 54.23,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M342.48,136.63h0c-2.89,0-5.23-2.34-5.23-5.23v-43.76c0-2.89,2.34-5.23,5.23-5.23h25.07c2.89,0,5.23,2.34,5.23,5.23v18.69c0,16.74-13.57,30.3-30.3,30.3Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 355.02,
    y1: 136.63,
    x2: 355.02,
    y2: 82.4,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 89.16,
    y: 64.65,
    width: 99.46,
    height: 58.54,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 89.16,
    y: -10496.69,
    width: 99.46,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 89.16,
    y: -10496.69,
    width: 99.46,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 138.89,
    y1: 123.19,
    x2: 138.89,
    y2: 64.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 89.16,
    y: 64.65,
    width: 99.46,
    height: 58.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M143.57,123.19h-39.37c-11.07,0-18.34-11.58-13.53-21.55,0,0,13.78-36.99,27.28-36.99h57.17c7.45,0,13.49,6.04,13.49,13.49h0c0,24.88-20.17,45.05-45.05,45.05Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 138.89,
    y1: 123.19,
    x2: 138.89,
    y2: 64.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 209.22,
    y: 64.65,
    width: 45.07,
    height: 58.54,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 209.22,
    y: -10496.69,
    width: 45.07,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 209.22,
    y: -10496.69,
    width: 45.07,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 231.76,
    x2: 231.76,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 209.22,
    y: 64.65,
    width: 45.07,
    height: 58.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M215.64,123.19h0c-3.54,0-6.42-2.87-6.42-6.42v-45.71c0-3.54,2.87-6.42,6.42-6.42h32.24c3.54,0,6.42,2.87,6.42,6.42v13.47c0,21.35-17.31,38.65-38.65,38.65Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 231.76,
    x2: 231.76,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 741.62,
    y: 64.65,
    width: 45.07,
    height: 58.54,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 741.62,
    y: -10496.69,
    width: 45.07,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 741.62,
    y: -10496.69,
    width: 45.07,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 764.16,
    x2: 764.16,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 741.62,
    y: 64.65,
    width: 45.07,
    height: 58.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M748.04,64.65h32.24c3.54,0,6.42,2.88,6.42,6.42v13.47c0,21.33-17.32,38.65-38.65,38.65h0c-3.54,0-6.42-2.88-6.42-6.42v-45.71c0-3.54,2.88-6.42,6.42-6.42Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 764.16,
    x2: 764.16,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-17",
    x: 402.92,
    y: 64.65,
    width: 139.28,
    height: 61.01,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-18",
    x: 402.92,
    y: -10496.69,
    width: 139.28,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 402.92,
    y: -10496.69,
    width: 139.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 472.56,
    y1: 125.65,
    x2: 472.56,
    y2: 64.65,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 402.92,
    y: 64.65,
    width: 139.28,
    height: 61.01,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M452.24,125.65h-49.32v-61.01h139.28v8.63c0,28.93-61.03,52.38-89.95,52.38Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 472.56,
    y1: 125.65,
    x2: 472.56,
    y2: 64.65,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-19",
    x: 573.27,
    y: 64.65,
    width: 139.28,
    height: 61.01,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-20",
    x: 573.27,
    y: -10496.69,
    width: 139.28,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 573.27,
    y: -10496.69,
    width: 139.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 642.91,
    y1: 125.65,
    x2: 642.91,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 573.27,
    y: 64.65,
    width: 139.28,
    height: 61.01,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M622.6,125.65h-49.32v-61.01h139.28v8.63c0,28.93-61.03,52.38-89.95,52.38Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 642.91,
    y1: 125.65,
    x2: 642.91,
    xlinkHref: "#linear-gradient-63"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M634.19,280.44c-26.01,0-48.77-2.58-61.26-6.45,5.58,6.11,30.88,10.72,61.26,10.72s55.68-4.61,61.26-10.72c-12.49,3.86-35.25,6.45-61.26,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M578.51,284.03h0c-1.92-.89-2.77-3.19-1.88-5.11l3.23-6.99c.89-1.92,3.19-2.77,5.11-1.88h0c1.92.89,2.77,3.19,1.88,5.11l-3.23,6.99c-.89,1.92-3.19,2.77-5.11,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M689.87,284.03h0c1.92-.89,2.77-3.19,1.88-5.11l-3.23-6.99c-.89-1.92-3.19-2.77-5.11-1.88h0c-1.92.89-2.77,3.19-1.88,5.11l3.23,6.99c.89,1.92,3.19,2.77,5.11,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M678.86,253.65s2.48,9.97,2.54,19.59c.06,9.62-1.55,21.12-.99,21.84.56.72,6.58-18.08,7.01-26.76.43-8.68-7.01-31.15-8.56-14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M152.44,280.44c-26.01,0-48.77-2.58-61.26-6.45,5.58,6.11,30.88,10.72,61.26,10.72s55.68-4.61,61.26-10.72c-12.49,3.86-35.25,6.45-61.26,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M96.76,284.03h0c-1.92-.89-2.77-3.19-1.88-5.11l3.23-6.99c.89-1.92,3.19-2.77,5.11-1.88h0c1.92.89,2.77,3.19,1.88,5.11l-3.23,6.99c-.89,1.92-3.19,2.77-5.11,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M208.12,284.03h0c1.92-.89,2.77-3.19,1.88-5.11l-3.23-6.99c-.89-1.92-3.19-2.77-5.11-1.88h0c-1.92.89-2.77,3.19-1.88,5.11l3.23,6.99c.89,1.92,3.19,2.77,5.11,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M196.31,253.65s2.48,9.97,2.54,19.59c.06,9.62-1.55,21.12-.99,21.84.56.72,6.58-18.08,7.01-26.76.43-8.68-7.01-31.15-8.56-14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M22.94,218.74v45.13c0,8.56,6.48,15.49,14.48,15.49h718.2s107.65-9.05,107.65-24.46v-36.16H22.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M152.26,228.65c-23.21,0-42.02,18.81-42.02,42.02s18.81,42.02,42.02,42.02,42.02-18.81,42.02-42.02-18.81-42.02-42.02-42.02ZM152.26,292.44c-12.02,0-21.77-9.75-21.77-21.77s9.75-21.77,21.77-21.77,21.77,9.75,21.77,21.77-9.75,21.77-21.77,21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M194.92,271.92v-2.18h-2.68c-.01-.44-.02-.88-.04-1.31l2.67-.23-.19-2.17-2.66.23c-.05-.44-.1-.87-.17-1.3l2.64-.47-.38-2.15-2.63.46c-.09-.43-.19-.86-.28-1.28l2.59-.69-.56-2.1-2.58.69c-.12-.42-.25-.84-.39-1.25l2.52-.92-.75-2.05-2.51.91c-.16-.41-.32-.82-.49-1.22l2.42-1.13-.92-1.97-2.42,1.13c-.19-.39-.39-.78-.6-1.17l2.32-1.34-1.09-1.89-2.31,1.33c-.23-.37-.47-.74-.71-1.1l2.2-1.54-1.25-1.78-2.19,1.53c-.26-.35-.53-.7-.8-1.04l2.06-1.73-1.4-1.67-2.05,1.72c-.29-.33-.58-.65-.88-.97l1.9-1.9-1.54-1.54-1.9,1.9c-.32-.3-.63-.6-.96-.89l1.73-2.06-1.67-1.4-1.72,2.05c-.34-.27-.68-.55-1.03-.81l1.54-2.19-1.78-1.25-1.53,2.19c-.36-.24-.73-.48-1.1-.71l1.34-2.32-1.89-1.09-1.33,2.31c-.38-.21-.77-.41-1.16-.6l1.13-2.43-1.97-.92-1.13,2.42c-.4-.18-.8-.34-1.21-.51l.92-2.52-2.05-.75-.91,2.51c-.41-.14-.83-.28-1.25-.4l.69-2.58-2.1-.56-.69,2.58c-.42-.1-.85-.21-1.28-.3l.46-2.63-2.15-.38-.46,2.63c-.43-.07-.87-.11-1.3-.17l.23-2.68-2.17-.19-.23,2.67c-.43-.03-.87-.05-1.31-.06v-2.69h-2.18v2.68c-.44,0-.88.02-1.31.04l-.23-2.67-2.17.19.23,2.66c-.44.05-.87.1-1.3.17l-.47-2.64-2.15.38.46,2.63c-.43.09-.86.19-1.28.28l-.69-2.59-2.1.56.69,2.58c-.42.12-.84.25-1.25.39l-.92-2.52-2.05.75.91,2.51c-.41.16-.82.32-1.22.49l-1.13-2.42-1.97.92,1.13,2.42c-.39.19-.78.39-1.17.6l-1.34-2.32-1.89,1.09,1.33,2.31c-.37.23-.74.47-1.1.71l-1.54-2.2-1.78,1.25,1.53,2.19c-.35.26-.7.53-1.04.8l-1.73-2.06-1.67,1.4,1.72,2.05c-.33.29-.65.58-.97.88l-1.9-1.9-1.54,1.54,1.9,1.9c-.3.32-.6.63-.89.96l-2.06-1.73-1.4,1.67,2.05,1.72c-.27.34-.55.68-.81,1.03l-2.19-1.54-1.25,1.78,2.19,1.53c-.24.36-.48.73-.71,1.1l-2.32-1.34-1.09,1.89,2.31,1.33c-.21.38-.41.77-.6,1.16l-2.43-1.13-.92,1.97,2.42,1.13c-.18.4-.34.8-.51,1.21l-2.52-.92-.74,2.05,2.51.91c-.14.41-.28.83-.4,1.25l-2.58-.69-.56,2.1,2.58.69c-.1.42-.21.85-.3,1.28l-2.63-.46-.38,2.15,2.63.46c-.07.43-.11.87-.17,1.3l-2.68-.23-.19,2.17,2.67.23c-.03.43-.05.87-.06,1.31h-2.69v2.18h2.68c.01.44.02.88.04,1.31l-2.67.23.19,2.17,2.66-.23c.05.44.1.87.17,1.3l-2.64.47.38,2.15,2.63-.46c.09.43.19.86.28,1.28l-2.59.69.56,2.1,2.58-.69c.12.42.25.84.39,1.25l-2.52.92.75,2.05,2.51-.91c.16.41.32.82.49,1.22l-2.42,1.13.92,1.97,2.42-1.13c.19.39.39.78.6,1.17l-2.32,1.34,1.09,1.89,2.31-1.33c.23.37.47.74.71,1.1l-2.2,1.54,1.25,1.78,2.19-1.53c.26.35.53.7.8,1.04l-2.06,1.73,1.4,1.67,2.05-1.72c.29.33.58.65.88.97l-1.9,1.9,1.54,1.54,1.9-1.9c.32.3.63.6.96.89l-1.73,2.06,1.67,1.4,1.72-2.05c.34.27.68.55,1.03.81l-1.54,2.19,1.78,1.25,1.53-2.19c.36.24.73.48,1.1.71l-1.34,2.32,1.89,1.09,1.33-2.31c.38.21.77.41,1.16.6l-1.13,2.43,1.97.92,1.13-2.42c.4.18.8.34,1.21.51l-.92,2.52,2.05.75.91-2.51c.41.14.83.28,1.25.4l-.69,2.58,2.1.56.69-2.58c.42.1.85.21,1.28.3l-.46,2.63,2.15.38.46-2.63c.43.07.87.11,1.3.17l-.23,2.68,2.17.19.23-2.67c.43.03.87.05,1.31.06v2.69h2.18v-2.68c.44,0,.88-.02,1.31-.04l.23,2.67,2.17-.19-.23-2.66c.44-.05.87-.1,1.3-.17l.47,2.64,2.15-.38-.46-2.63c.43-.09.86-.19,1.28-.29l.69,2.59,2.1-.56-.69-2.58c.42-.12.84-.25,1.25-.39l.92,2.52,2.05-.75-.91-2.51c.41-.16.82-.32,1.22-.49l1.13,2.42,1.97-.92-1.13-2.42c.39-.19.78-.39,1.17-.6l1.34,2.32,1.89-1.09-1.33-2.31c.37-.23.74-.47,1.1-.71l1.54,2.2,1.78-1.25-1.53-2.19c.35-.26.7-.53,1.04-.8l1.73,2.06,1.67-1.4-1.72-2.05c.33-.29.65-.58.97-.88l1.9,1.9,1.54-1.54-1.9-1.9c.3-.32.6-.63.89-.96l2.06,1.73,1.4-1.67-2.05-1.72c.27-.34.55-.68.81-1.03l2.19,1.54,1.25-1.78-2.19-1.53c.24-.36.48-.73.71-1.1l2.32,1.34,1.09-1.89-2.31-1.33c.21-.38.41-.77.6-1.16l2.43,1.13.92-1.97-2.42-1.13c.18-.4.34-.8.51-1.21l2.52.92.75-2.05-2.51-.91c.14-.41.28-.83.4-1.25l2.58.69.56-2.1-2.58-.69c.1-.42.21-.85.3-1.28l2.63.46.38-2.15-2.63-.46c.07-.43.11-.87.17-1.3l2.68.23.19-2.17-2.67-.23c.03-.43.05-.87.06-1.31h2.69ZM152.26,292.44c-12.02,0-21.77-9.75-21.77-21.77s9.75-21.77,21.77-21.77,21.77,9.75,21.77,21.77-9.75,21.77-21.77,21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.26,232.59c-21.03,0-38.07,17.05-38.07,38.07s17.05,38.07,38.07,38.07,38.07-17.05,38.07-38.07-17.05-38.07-38.07-38.07ZM152.26,292.44c-12.02,0-21.77-9.75-21.77-21.77s9.75-21.77,21.77-21.77,21.77,9.75,21.77,21.77-9.75,21.77-21.77,21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M152.26,244.1c-14.68,0-26.57,11.9-26.57,26.57s11.9,26.57,26.57,26.57,26.57-11.9,26.57-26.57-11.9-26.57-26.57-26.57ZM152.26,293.73c-12.73,0-23.06-10.32-23.06-23.06s10.32-23.06,23.06-23.06,23.06,10.32,23.06,23.06-10.32,23.06-23.06,23.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M152.26,246.59c-13.3,0-24.08,10.78-24.08,24.08s10.78,24.08,24.08,24.08,24.08-10.78,24.08-24.08-10.78-24.08-24.08-24.08ZM152.26,291.56c-11.54,0-20.89-9.35-20.89-20.89s9.35-20.89,20.89-20.89,20.89,9.35,20.89,20.89-9.35,20.89-20.89,20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M152.26,248.38c-12.31,0-22.29,9.98-22.29,22.29s9.98,22.29,22.29,22.29,22.29-9.98,22.29-22.29-9.98-22.29-22.29-22.29ZM139.26,283.52c-.92.53-2.1.22-2.63-.71l-3.35-5.8c-.53-.92-.22-2.1.71-2.63.92-.53,2.1-.22,2.63.71l3.35,5.8c.53.92.22,2.1-.71,2.63ZM140.62,259.33l-3.35,5.8c-.53.92-1.71,1.24-2.63.71s-1.24-1.71-.71-2.63l3.35-5.8c.53-.92,1.71-1.24,2.63-.71h0c.92.53,1.24,1.71.71,2.63ZM154.96,290.28h-6.7c-1.07,0-1.93-.86-1.93-1.93s.86-1.93,1.93-1.93h6.7c1.06,0,1.93.86,1.93,1.93s-.86,1.93-1.93,1.93ZM156.26,254.91h-6.7c-1.07,0-1.93-.86-1.93-1.93s.86-1.93,1.93-1.93h6.7c1.06,0,1.93.86,1.93,1.93s-.86,1.93-1.93,1.93ZM170.59,278.14l-3.35,5.8c-.53.92-1.71,1.24-2.63.71-.92-.53-1.24-1.71-.71-2.63l3.35-5.8c.53-.92,1.71-1.24,2.63-.71s1.24,1.71.71,2.63ZM170.54,266.96c-.92.53-2.1.22-2.63-.71l-3.35-5.8c-.53-.92-.22-2.1.71-2.63h0c.92-.53,2.1-.22,2.63.71l3.35,5.8c.53.92.22,2.1-.71,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M152.26,247.3c-12.9,0-23.37,10.46-23.37,23.37s10.46,23.37,23.37,23.37,23.37-10.46,23.37-23.37-10.46-23.37-23.37-23.37ZM138.63,284.14c-.97.56-2.2.23-2.76-.74l-3.51-6.08c-.56-.97-.23-2.2.74-2.76s2.2-.23,2.76.74l3.51,6.08c.56.97.23,2.2-.74,2.76ZM140.05,258.78l-3.51,6.08c-.56.97-1.79,1.3-2.76.74-.97-.56-1.3-1.79-.74-2.76l3.51-6.08c.56-.97,1.79-1.3,2.76-.74h0c.97.56,1.3,1.79.74,2.76ZM155.09,291.23h-7.02c-1.12,0-2.02-.91-2.02-2.02s.9-2.02,2.02-2.02h7.02c1.12,0,2.02.9,2.02,2.02s-.91,2.02-2.02,2.02ZM156.45,254.15h-7.02c-1.12,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02h7.02c1.12,0,2.02.91,2.02,2.02s-.9,2.02-2.02,2.02ZM171.48,278.5l-3.51,6.08c-.56.97-1.79,1.3-2.76.74-.97-.56-1.3-1.79-.74-2.76l3.51-6.08c.56-.97,1.79-1.3,2.76-.74.97.56,1.3,1.79.74,2.76ZM171.42,266.78c-.97.56-2.2.23-2.76-.74l-3.51-6.08c-.56-.97-.23-2.2.74-2.76h0c.97-.56,2.2-.23,2.76.74l3.51,6.08c.56.97.23,2.2-.74,2.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-94",
    cx: 152.26,
    cy: 270.67,
    r: 14.24,
    transform: "translate(-6.71 3.89) rotate(-1.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-100",
    cx: 152.26,
    cy: 270.67,
    r: 8.69,
    transform: "translate(-10.27 6.04) rotate(-2.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "153.4 280.43 151.48 280.43 150.51 282.1 151.48 283.77 153.4 283.77 154.37 282.1 153.4 280.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M153.39,282.1c0,.52-.42.95-.95.95s-.95-.42-.95-.95.42-.95.95-.95.95.42.95.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "159.97 276.76 158.61 278.13 159.11 279.99 160.97 280.49 162.33 279.12 161.84 277.26 159.97 276.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M161.14,277.96c.37.37.37.97,0,1.34-.37.37-.97.37-1.34,0-.37-.37-.37-.97,0-1.34.37-.37.97-.37,1.34,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "162.02 269.52 162.02 271.45 163.69 272.42 165.36 271.45 165.36 269.52 163.69 268.56 162.02 269.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M163.69,269.54c.52,0,.95.42.95.95s-.42.95-.95.95-.95-.42-.95-.95.42-.95.95-.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "158.36 262.96 159.72 264.32 161.58 263.82 162.08 261.96 160.72 260.59 158.85 261.09 158.36 262.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M159.55,261.79c.37-.37.97-.37,1.34,0s.37.97,0,1.34-.97.37-1.34,0c-.37-.37-.37-.97,0-1.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "151.12 260.91 153.05 260.91 154.01 259.24 153.05 257.57 151.12 257.57 150.15 259.24 151.12 260.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M151.14,259.24c0-.52.42-.95.95-.95s.95.42.95.95-.42.95-.95.95-.95-.42-.95-.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "144.55 264.57 145.91 263.21 145.41 261.35 143.55 260.85 142.19 262.21 142.69 264.07 144.55 264.57"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 144.05,
    cy: 262.71,
    r: 0.95
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "142.5 271.81 142.5 269.88 140.83 268.92 139.16 269.88 139.16 271.81 140.83 272.78 142.5 271.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M140.83,271.79c-.52,0-.95-.42-.95-.95s.42-.95.95-.95.95.42.95.95-.42.95-.95.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "146.17 278.38 144.8 277.02 142.94 277.52 142.44 279.38 143.8 280.74 145.67 280.24 146.17 278.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M144.97,279.55c-.37.37-.97.37-1.34,0-.37-.37-.37-.97,0-1.34.37-.37.97-.37,1.34,0,.37.37.37.97,0,1.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 152.26,
    cy: 270.67,
    r: 4.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 635.07,
    cy: 270.67,
    r: 18.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M634.96,228.65c-23.21,0-42.02,18.81-42.02,42.02s18.81,42.02,42.02,42.02,42.02-18.81,42.02-42.02-18.81-42.02-42.02-42.02ZM634.96,292.44c-12.02,0-21.77-9.75-21.77-21.77s9.75-21.77,21.77-21.77,21.77,9.75,21.77,21.77-9.75,21.77-21.77,21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M677.62,271.92v-2.18h-2.68c-.01-.44-.02-.88-.04-1.31l2.67-.23-.19-2.17-2.66.23c-.05-.44-.1-.87-.17-1.3l2.64-.47-.38-2.15-2.63.46c-.09-.43-.19-.86-.28-1.28l2.59-.69-.56-2.1-2.58.69c-.12-.42-.25-.84-.39-1.25l2.52-.92-.75-2.05-2.51.91c-.16-.41-.32-.82-.49-1.22l2.42-1.13-.92-1.97-2.42,1.13c-.19-.39-.39-.78-.6-1.17l2.32-1.34-1.09-1.89-2.31,1.33c-.23-.37-.47-.74-.71-1.1l2.2-1.54-1.25-1.78-2.19,1.53c-.26-.35-.53-.7-.8-1.04l2.06-1.73-1.4-1.67-2.05,1.72c-.29-.33-.58-.65-.88-.97l1.9-1.9-1.54-1.54-1.9,1.9c-.32-.3-.63-.6-.96-.89l1.73-2.06-1.67-1.4-1.72,2.05c-.34-.27-.68-.55-1.03-.81l1.54-2.19-1.78-1.25-1.53,2.19c-.36-.24-.73-.48-1.1-.71l1.34-2.32-1.89-1.09-1.33,2.31c-.38-.21-.77-.41-1.16-.6l1.13-2.43-1.97-.92-1.13,2.42c-.4-.18-.8-.34-1.21-.51l.92-2.52-2.05-.75-.91,2.51c-.41-.14-.83-.28-1.25-.4l.69-2.58-2.1-.56-.69,2.58c-.42-.1-.85-.21-1.28-.3l.46-2.63-2.15-.38-.46,2.63c-.43-.07-.87-.11-1.3-.17l.23-2.68-2.17-.19-.23,2.67c-.43-.03-.87-.05-1.31-.06v-2.69h-2.18v2.68c-.44,0-.88.02-1.31.04l-.23-2.67-2.17.19.23,2.66c-.44.05-.87.1-1.3.17l-.47-2.64-2.15.38.46,2.63c-.43.09-.86.19-1.28.28l-.69-2.59-2.1.56.69,2.58c-.42.12-.84.25-1.25.39l-.92-2.52-2.05.75.91,2.51c-.41.16-.82.32-1.22.49l-1.13-2.42-1.97.92,1.13,2.42c-.39.19-.78.39-1.17.6l-1.34-2.32-1.89,1.09,1.33,2.31c-.37.23-.74.47-1.1.71l-1.54-2.2-1.78,1.25,1.53,2.19c-.35.26-.7.53-1.04.8l-1.73-2.06-1.67,1.4,1.72,2.05c-.33.29-.65.58-.97.88l-1.9-1.9-1.54,1.54,1.9,1.9c-.3.32-.6.63-.89.96l-2.06-1.73-1.4,1.67,2.05,1.72c-.27.34-.55.68-.81,1.03l-2.19-1.54-1.25,1.78,2.19,1.53c-.24.36-.48.73-.71,1.1l-2.32-1.34-1.09,1.89,2.31,1.33c-.21.38-.41.77-.6,1.16l-2.43-1.13-.92,1.97,2.42,1.13c-.18.4-.34.8-.51,1.21l-2.52-.92-.75,2.05,2.51.91c-.14.41-.28.83-.4,1.25l-2.58-.69-.56,2.1,2.58.69c-.1.42-.21.85-.3,1.28l-2.63-.46-.38,2.15,2.63.46c-.07.43-.11.87-.17,1.3l-2.68-.23-.19,2.17,2.67.23c-.03.43-.05.87-.06,1.31h-2.69v2.18h2.68c0,.44.02.88.04,1.31l-2.67.23.19,2.17,2.66-.23c.05.44.1.87.17,1.3l-2.64.47.38,2.15,2.63-.46c.09.43.19.86.28,1.28l-2.59.69.56,2.1,2.58-.69c.12.42.25.84.39,1.25l-2.52.92.75,2.05,2.51-.91c.16.41.32.82.49,1.22l-2.42,1.13.92,1.97,2.42-1.13c.19.39.39.78.6,1.17l-2.32,1.34,1.09,1.89,2.31-1.33c.23.37.47.74.71,1.1l-2.2,1.54,1.25,1.78,2.19-1.53c.26.35.53.7.8,1.04l-2.06,1.73,1.4,1.67,2.05-1.72c.29.33.58.65.88.97l-1.9,1.9,1.54,1.54,1.9-1.9c.32.3.63.6.96.89l-1.73,2.06,1.67,1.4,1.72-2.05c.34.27.68.55,1.03.81l-1.54,2.19,1.78,1.25,1.53-2.19c.36.24.73.48,1.1.71l-1.34,2.32,1.89,1.09,1.33-2.31c.38.21.77.41,1.16.6l-1.13,2.43,1.97.92,1.13-2.42c.4.18.8.34,1.21.51l-.92,2.52,2.05.75.91-2.51c.41.14.83.28,1.25.4l-.69,2.58,2.1.56.69-2.58c.42.1.85.21,1.28.3l-.46,2.63,2.15.38.46-2.63c.43.07.87.11,1.3.17l-.23,2.68,2.17.19.23-2.67c.43.03.87.05,1.31.06v2.69h2.18v-2.68c.44,0,.88-.02,1.31-.04l.23,2.67,2.17-.19-.23-2.66c.44-.05.87-.1,1.3-.17l.47,2.64,2.15-.38-.46-2.63c.43-.09.86-.19,1.28-.29l.69,2.59,2.1-.56-.69-2.58c.42-.12.84-.25,1.25-.39l.92,2.52,2.05-.75-.91-2.51c.41-.16.82-.32,1.22-.49l1.13,2.42,1.97-.92-1.13-2.42c.39-.19.78-.39,1.17-.6l1.34,2.32,1.89-1.09-1.33-2.31c.37-.23.74-.47,1.1-.71l1.54,2.2,1.78-1.25-1.53-2.19c.35-.26.7-.53,1.04-.8l1.73,2.06,1.67-1.4-1.72-2.05c.33-.29.65-.58.97-.88l1.9,1.9,1.54-1.54-1.9-1.9c.3-.32.6-.63.89-.96l2.06,1.73,1.4-1.67-2.05-1.72c.27-.34.55-.68.81-1.03l2.19,1.54,1.25-1.78-2.19-1.53c.24-.36.48-.73.71-1.1l2.32,1.34,1.09-1.89-2.31-1.33c.21-.38.41-.77.6-1.16l2.43,1.13.92-1.97-2.42-1.13c.18-.4.34-.8.51-1.21l2.52.92.75-2.05-2.51-.91c.14-.41.28-.83.4-1.25l2.58.69.56-2.1-2.58-.69c.1-.42.21-.85.29-1.28l2.63.46.38-2.15-2.63-.46c.07-.43.11-.87.17-1.3l2.68.23.19-2.17-2.67-.23c.03-.43.05-.87.06-1.31h2.69ZM634.96,292.44c-12.02,0-21.77-9.75-21.77-21.77s9.75-21.77,21.77-21.77,21.77,9.75,21.77,21.77-9.75,21.77-21.77,21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M634.96,232.59c-21.03,0-38.07,17.05-38.07,38.07s17.05,38.07,38.07,38.07,38.07-17.05,38.07-38.07-17.05-38.07-38.07-38.07ZM634.96,292.44c-12.02,0-21.77-9.75-21.77-21.77s9.75-21.77,21.77-21.77,21.77,9.75,21.77,21.77-9.75,21.77-21.77,21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M634.96,244.1c-14.67,0-26.57,11.9-26.57,26.57s11.9,26.57,26.57,26.57,26.57-11.9,26.57-26.57-11.9-26.57-26.57-26.57ZM634.96,293.73c-12.73,0-23.06-10.32-23.06-23.06s10.32-23.06,23.06-23.06,23.06,10.32,23.06,23.06-10.32,23.06-23.06,23.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M634.96,246.59c-13.3,0-24.08,10.78-24.08,24.08s10.78,24.08,24.08,24.08,24.08-10.78,24.08-24.08-10.78-24.08-24.08-24.08ZM634.96,291.56c-11.54,0-20.89-9.35-20.89-20.89s9.35-20.89,20.89-20.89,20.89,9.35,20.89,20.89-9.35,20.89-20.89,20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M634.96,247.3c-12.9,0-23.37,10.46-23.37,23.37s10.46,23.37,23.37,23.37,23.37-10.46,23.37-23.37-10.46-23.37-23.37-23.37ZM647.35,256.04c1.37-.79,3.92,1.08,5.71,4.17,1.79,3.09,2.12,6.24.76,7.03s-3.92-1.08-5.71-4.17-2.12-6.24-.76-7.03ZM622.56,285.29c-1.37.79-3.92-1.08-5.71-4.17s-2.12-6.24-.76-7.03c1.37-.79,3.92,1.08,5.71,4.17,1.79,3.09,2.12,6.24.76,7.03ZM621.8,263.07c-1.79,3.09-4.34,4.96-5.71,4.17-1.37-.79-1.03-3.94.76-7.03,1.79-3.09,4.34-4.96,5.71-4.17,1.37.79,1.03,3.94-.76,7.03ZM634.96,291.57c-3.57,0-6.47-1.28-6.47-2.86s2.9-2.86,6.47-2.86,6.47,1.28,6.47,2.86-2.9,2.86-6.47,2.86ZM634.96,255.48c-3.57,0-6.47-1.28-6.47-2.86s2.9-2.86,6.47-2.86,6.47,1.28,6.47,2.86-2.9,2.86-6.47,2.86ZM653.06,281.12c-1.79,3.09-4.34,4.96-5.71,4.17-1.37-.79-1.03-3.94.76-7.03,1.79-3.09,4.34-4.96,5.71-4.17,1.37.79,1.03,3.94-.76,7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M634.96,247.3c-12.04,0-21.94,9.1-23.22,20.8.89,2.46,2.17,4.74,3.75,6.77.14-.34.33-.62.61-.78,1.37-.79,3.92,1.08,5.71,4.17.61,1.06,1.04,2.12,1.3,3.1,3.52,1.93,7.55,3.03,11.85,3.03s8.33-1.1,11.85-3.03c.26-.98.69-2.04,1.3-3.1,1.79-3.09,4.34-4.96,5.71-4.17.28.16.47.44.61.78,1.58-2.03,2.86-4.31,3.75-6.77-1.28-11.69-11.18-20.8-23.22-20.8ZM621.8,263.07c-1.79,3.09-4.34,4.96-5.71,4.17-1.37-.79-1.03-3.94.76-7.03,1.79-3.09,4.34-4.96,5.71-4.17s1.03,3.94-.76,7.03ZM634.96,255.48c-3.57,0-6.47-1.28-6.47-2.86s2.9-2.86,6.47-2.86,6.47,1.28,6.47,2.86-2.9,2.86-6.47,2.86ZM653.82,267.25c-1.37.79-3.92-1.08-5.71-4.17-1.79-3.09-2.12-6.24-.76-7.03,1.37-.79,3.92,1.08,5.71,4.17,1.79,3.09,2.12,6.24.76,7.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "636.1 280.43 634.17 280.43 633.21 282.1 634.17 283.77 636.1 283.77 637.06 282.1 636.1 280.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M636.08,282.1c0,.52-.42.95-.95.95s-.95-.42-.95-.95.42-.95.95-.95.95.42.95.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "642.67 276.76 641.3 278.13 641.8 279.99 643.67 280.49 645.03 279.12 644.53 277.26 642.67 276.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M643.84,277.96c.37.37.37.97,0,1.34-.37.37-.97.37-1.34,0s-.37-.97,0-1.34c.37-.37.97-.37,1.34,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "644.72 269.52 644.72 271.45 646.39 272.42 648.06 271.45 648.06 269.52 646.39 268.56 644.72 269.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M646.39,269.54c.52,0,.95.42.95.95s-.42.95-.95.95-.95-.42-.95-.95.42-.95.95-.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "641.05 262.96 642.41 264.32 644.28 263.82 644.77 261.96 643.41 260.59 641.55 261.09 641.05 262.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M642.24,261.79c.37-.37.97-.37,1.34,0,.37.37.37.97,0,1.34-.37.37-.97.37-1.34,0s-.37-.97,0-1.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "633.81 260.91 635.74 260.91 636.7 259.24 635.74 257.57 633.81 257.57 632.85 259.24 633.81 260.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M633.83,259.24c0-.52.42-.95.95-.95s.95.42.95.95-.42.95-.95.95-.95-.42-.95-.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "627.24 264.57 628.61 263.21 628.11 261.35 626.24 260.85 624.88 262.21 625.38 264.07 627.24 264.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M626.08,263.38c-.37-.37-.37-.97,0-1.34.37-.37.97-.37,1.34,0,.37.37.37.97,0,1.34-.37.37-.97.37-1.34,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "625.19 271.81 625.19 269.88 623.52 268.92 621.85 269.88 621.85 271.81 623.52 272.78 625.19 271.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M623.52,271.79c-.52,0-.95-.42-.95-.95s.42-.95.95-.95.95.42.95.95-.42.95-.95.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "628.86 278.38 627.5 277.02 625.63 277.52 625.14 279.38 626.5 280.74 628.36 280.24 628.86 278.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 627,
    cy: 278.88,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 634.96,
    cy: 270.67,
    r: 8.69,
    transform: "translate(-12.69 31.97) rotate(-2.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M641.05,270.67c0,3.37-2.73,6.09-6.09,6.09s-6.09-2.73-6.09-6.09,2.73-6.09,6.09-6.09,6.09,2.73,6.09,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M827.77,141.86c0-40.66-2.54-87.34-22.3-87.34H111.1c-15.14,0-29.94,18.54-41.68,52.21-6.11,17.54-11.02,38.44-14.16,59.41h-7.23v52.6h779.72v-76.88ZM727.24,62.15h69.38c17.35,0,20.7,83.73,12.41,83.73h-81.79V62.15ZM559.95,62.15h158.77v83.73h-158.77V62.15ZM391.98,62.15h158.75v83.73h-158.75V62.15ZM224,62.15h158.75v83.73h-158.75V62.15ZM72.29,147.76s8.13-40.32,21.99-65.02h91.23v51.53c0,10.92-8.75,19.77-19.55,19.77h-90.21c-2.54,0-4.31-3.21-3.46-6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M167.08,124.31c.99-1.22,1.52-2.82,1.31-4.5l-1.4-11.28c-.41-3.26-3.41-5.6-6.67-5.19l-.2.02c-3.26.41-5.6,3.41-5.19,6.67l1.4,11.28c.21,1.69,1.13,3.12,2.41,4.06-2.39,1.51-4.13,4-4.57,7l-4.84,33.43c-.79,5.43,3.01,10.51,8.44,11.3,5.43.79,10.51-3.01,11.3-8.44l4.84-33.43c.71-4.88-2.29-9.47-6.84-10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M58.64,147.23c-.11,1.09.67,2.09,1.73,2.38l13.45,3.66-1.58,5.79c-.22.79-1.03,1.26-1.83,1.05h0c-.54-.15-1.1.17-1.25.71l-8.18,30.07,12.22,3.33,8.18-30.07c.15-.54-.17-1.1-.71-1.25h0c-.79-.22-1.26-1.03-1.05-1.83l1.58-5.79,13.45,3.66c1.06.29,2.24-.17,2.7-1.17.58-1.28-.13-2.71-1.43-3.06l-34.52-9.39c-1.29-.35-2.63.52-2.78,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M179.09,126.01c.06-1.16.09-2.32.09-3.49v-12.81c0-1.96-2.01-3.48-4.19-2.83-.9.27-1.55.96-1.88,1.78-1.32.2-2.43.61-2.43,1.11v12.04c-.02,9.38-3.13,18.59-9,26.63l-16.15,22.11c-.23.67,2.16,1.35,5.03,1.94l-.62.96h-34.74c-3.13,0-5.67,2.39-5.67,5.34h0c0,2.75,2.22,5.05,5.12,5.32l18.67,1.7,4.84,35.52h22.99l-9.59-33.87,8.6.78c3.33.3,6.21-2.16,6.21-5.32v-4.14c0-.8-.2-1.55-.53-2.22.27-.31.5-.66.63-1.07l9.56-31.75c1.43-4.77,2.37-9.65,2.82-14.57h4.24v-3.17h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 109.9,
    y: 154.74,
    width: 50.44,
    height: 44.08,
    rx: 9.89,
    ry: 9.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 271.26,
    y: 221.7,
    width: 111.68,
    height: 33.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "271.26 221.7 276.33 226.45 276.33 221.7 271.26 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "271.26 226.45 276.33 231.19 276.33 226.45 271.26 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "271.26 231.19 276.33 235.93 276.33 231.19 271.26 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "271.26 235.93 276.33 240.68 276.33 235.93 271.26 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "271.26 240.68 276.33 245.42 276.33 240.68 271.26 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "271.26 245.42 276.33 250.17 276.33 245.42 271.26 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "271.26 250.17 276.33 254.91 276.33 250.17 271.26 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "276.33 221.7 281.41 226.45 281.41 221.7 276.33 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "276.33 226.45 281.41 231.19 281.41 226.45 276.33 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "276.33 231.19 281.41 235.93 281.41 231.19 276.33 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "276.33 235.93 281.41 240.68 281.41 235.93 276.33 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "276.33 240.68 281.41 245.42 281.41 240.68 276.33 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "276.33 245.42 281.41 250.17 281.41 245.42 276.33 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "276.33 250.17 281.41 254.91 281.41 250.17 276.33 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "281.41 221.7 286.49 226.45 286.49 221.7 281.41 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "281.41 226.45 286.49 231.19 286.49 226.45 281.41 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "281.41 231.19 286.49 235.93 286.49 231.19 281.41 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "281.41 235.93 286.49 240.68 286.49 235.93 281.41 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "281.41 240.68 286.49 245.42 286.49 240.68 281.41 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "281.41 245.42 286.49 250.17 286.49 245.42 281.41 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "281.41 250.17 286.49 254.91 286.49 250.17 281.41 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "286.49 221.7 291.56 226.45 291.56 221.7 286.49 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "286.49 226.45 291.56 231.19 291.56 226.45 286.49 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "286.49 231.19 291.56 235.93 291.56 231.19 286.49 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "286.49 235.93 291.56 240.68 291.56 235.93 286.49 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "286.49 240.68 291.56 245.42 291.56 240.68 286.49 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "286.49 245.42 291.56 250.17 291.56 245.42 286.49 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "286.49 250.17 291.56 254.91 291.56 250.17 286.49 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "291.56 221.7 296.64 226.45 296.64 221.7 291.56 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "291.56 226.45 296.64 231.19 296.64 226.45 291.56 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "291.56 231.19 296.64 235.93 296.64 231.19 291.56 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "291.56 235.93 296.64 240.68 296.64 235.93 291.56 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "291.56 240.68 296.64 245.42 296.64 240.68 291.56 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "291.56 245.42 296.64 250.17 296.64 245.42 291.56 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "291.56 250.17 296.64 254.91 296.64 250.17 291.56 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "296.64 221.7 301.72 226.45 301.72 221.7 296.64 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "296.64 226.45 301.72 231.19 301.72 226.45 296.64 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "296.64 231.19 301.72 235.93 301.72 231.19 296.64 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "296.64 235.93 301.72 240.68 301.72 235.93 296.64 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "296.64 240.68 301.72 245.42 301.72 240.68 296.64 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "296.64 245.42 301.72 250.17 301.72 245.42 296.64 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "296.64 250.17 301.72 254.91 301.72 250.17 296.64 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "301.72 221.7 306.79 226.45 306.79 221.7 301.72 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "301.72 226.45 306.79 231.19 306.79 226.45 301.72 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "301.72 231.19 306.79 235.93 306.79 231.19 301.72 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "301.72 235.93 306.79 240.68 306.79 235.93 301.72 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "301.72 240.68 306.79 245.42 306.79 240.68 301.72 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "301.72 245.42 306.79 250.17 306.79 245.42 301.72 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "301.72 250.17 306.79 254.91 306.79 250.17 301.72 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "306.79 221.7 311.87 226.45 311.87 221.7 306.79 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "306.79 226.45 311.87 231.19 311.87 226.45 306.79 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "306.79 231.19 311.87 235.93 311.87 231.19 306.79 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "306.79 235.93 311.87 240.68 311.87 235.93 306.79 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "306.79 240.68 311.87 245.42 311.87 240.68 306.79 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "306.79 245.42 311.87 250.17 311.87 245.42 306.79 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "306.79 250.17 311.87 254.91 311.87 250.17 306.79 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.87 221.7 316.94 226.45 316.94 221.7 311.87 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.87 226.45 316.94 231.19 316.94 226.45 311.87 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.87 231.19 316.94 235.93 316.94 231.19 311.87 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.87 235.93 316.94 240.68 316.94 235.93 311.87 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.87 240.68 316.94 245.42 316.94 240.68 311.87 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.87 245.42 316.94 250.17 316.94 245.42 311.87 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "311.87 250.17 316.94 254.91 316.94 250.17 311.87 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.94 221.7 322.02 226.45 322.02 221.7 316.94 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.94 226.45 322.02 231.19 322.02 226.45 316.94 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.94 231.19 322.02 235.93 322.02 231.19 316.94 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.94 235.93 322.02 240.68 322.02 235.93 316.94 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.94 240.68 322.02 245.42 322.02 240.68 316.94 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.94 245.42 322.02 250.17 322.02 245.42 316.94 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.94 250.17 322.02 254.91 322.02 250.17 316.94 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "322.02 221.7 327.1 226.45 327.1 221.7 322.02 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "322.02 226.45 327.1 231.19 327.1 226.45 322.02 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "322.02 231.19 327.1 235.93 327.1 231.19 322.02 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "322.02 235.93 327.1 240.68 327.1 235.93 322.02 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "322.02 240.68 327.1 245.42 327.1 240.68 322.02 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "322.02 245.42 327.1 250.17 327.1 245.42 322.02 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "322.02 250.17 327.1 254.91 327.1 250.17 322.02 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "327.1 221.7 332.17 226.45 332.17 221.7 327.1 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "327.1 226.45 332.17 231.19 332.17 226.45 327.1 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "327.1 231.19 332.17 235.93 332.17 231.19 327.1 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "327.1 235.93 332.17 240.68 332.17 235.93 327.1 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "327.1 240.68 332.17 245.42 332.17 240.68 327.1 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "327.1 245.42 332.17 250.17 332.17 245.42 327.1 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "327.1 250.17 332.17 254.91 332.17 250.17 327.1 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.17 221.7 337.25 226.45 337.25 221.7 332.17 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.17 226.45 337.25 231.19 337.25 226.45 332.17 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.17 231.19 337.25 235.93 337.25 231.19 332.17 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.17 235.93 337.25 240.68 337.25 235.93 332.17 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.17 240.68 337.25 245.42 337.25 240.68 332.17 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.17 245.42 337.25 250.17 337.25 245.42 332.17 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "332.17 250.17 337.25 254.91 337.25 250.17 332.17 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "337.25 221.7 342.33 226.45 342.33 221.7 337.25 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "337.25 226.45 342.33 231.19 342.33 226.45 337.25 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "337.25 231.19 342.33 235.93 342.33 231.19 337.25 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "337.25 235.93 342.33 240.68 342.33 235.93 337.25 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "337.25 240.68 342.33 245.42 342.33 240.68 337.25 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "337.25 245.42 342.33 250.17 342.33 245.42 337.25 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "337.25 250.17 342.33 254.91 342.33 250.17 337.25 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "342.33 221.7 347.4 226.45 347.4 221.7 342.33 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "342.33 226.45 347.4 231.19 347.4 226.45 342.33 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "342.33 231.19 347.4 235.93 347.4 231.19 342.33 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "342.33 235.93 347.4 240.68 347.4 235.93 342.33 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "342.33 240.68 347.4 245.42 347.4 240.68 342.33 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "342.33 245.42 347.4 250.17 347.4 245.42 342.33 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "342.33 250.17 347.4 254.91 347.4 250.17 342.33 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "347.4 221.7 352.48 226.45 352.48 221.7 347.4 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "347.4 226.45 352.48 231.19 352.48 226.45 347.4 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "347.4 231.19 352.48 235.93 352.48 231.19 347.4 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "347.4 235.93 352.48 240.68 352.48 235.93 347.4 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "347.4 240.68 352.48 245.42 352.48 240.68 347.4 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "347.4 245.42 352.48 250.17 352.48 245.42 347.4 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "347.4 250.17 352.48 254.91 352.48 250.17 347.4 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "352.48 221.7 357.56 226.45 357.56 221.7 352.48 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "352.48 226.45 357.56 231.19 357.56 226.45 352.48 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "352.48 231.19 357.56 235.93 357.56 231.19 352.48 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "352.48 235.93 357.56 240.68 357.56 235.93 352.48 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "352.48 240.68 357.56 245.42 357.56 240.68 352.48 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "352.48 245.42 357.56 250.17 357.56 245.42 352.48 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "352.48 250.17 357.56 254.91 357.56 250.17 352.48 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "357.56 221.7 362.63 226.45 362.63 221.7 357.56 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "357.56 226.45 362.63 231.19 362.63 226.45 357.56 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "357.56 231.19 362.63 235.93 362.63 231.19 357.56 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "357.56 235.93 362.63 240.68 362.63 235.93 357.56 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "357.56 240.68 362.63 245.42 362.63 240.68 357.56 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "357.56 245.42 362.63 250.17 362.63 245.42 357.56 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "357.56 250.17 362.63 254.91 362.63 250.17 357.56 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "362.63 221.7 367.71 226.45 367.71 221.7 362.63 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "362.63 226.45 367.71 231.19 367.71 226.45 362.63 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "362.63 231.19 367.71 235.93 367.71 231.19 362.63 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "362.63 235.93 367.71 240.68 367.71 235.93 362.63 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "362.63 240.68 367.71 245.42 367.71 240.68 362.63 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "362.63 245.42 367.71 250.17 367.71 245.42 362.63 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "362.63 250.17 367.71 254.91 367.71 250.17 362.63 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "367.71 221.7 372.79 226.45 372.79 221.7 367.71 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "367.71 226.45 372.79 231.19 372.79 226.45 367.71 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "367.71 231.19 372.79 235.93 372.79 231.19 367.71 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "367.71 235.93 372.79 240.68 372.79 235.93 367.71 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "367.71 240.68 372.79 245.42 372.79 240.68 367.71 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "367.71 245.42 372.79 250.17 372.79 245.42 367.71 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "367.71 250.17 372.79 254.91 372.79 250.17 367.71 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.79 221.7 377.86 226.45 377.86 221.7 372.79 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.79 226.45 377.86 231.19 377.86 226.45 372.79 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.79 231.19 377.86 235.93 377.86 231.19 372.79 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.79 235.93 377.86 240.68 377.86 235.93 372.79 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.79 240.68 377.86 245.42 377.86 240.68 372.79 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.79 245.42 377.86 250.17 377.86 245.42 372.79 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "372.79 250.17 377.86 254.91 377.86 250.17 372.79 250.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "377.86 221.7 382.94 226.45 382.94 221.7 377.86 221.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "377.86 226.45 382.94 231.19 382.94 226.45 377.86 226.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "377.86 231.19 382.94 235.93 382.94 231.19 377.86 231.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "377.86 235.93 382.94 240.68 382.94 235.93 377.86 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "377.86 240.68 382.94 245.42 382.94 240.68 377.86 240.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "377.86 245.42 382.94 250.17 382.94 245.42 377.86 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "377.86 250.17 382.94 254.91 382.94 250.17 377.86 250.17"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 271.26,
    y: 236.9,
    width: 111.68,
    height: 18.01,
    transform: "translate(654.2 491.81) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 271.26,
    y: 226.45,
    width: 111.68,
    height: 7.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M392.39,236.9h-16.68c-3.12,0-5.65-2.54-5.65-5.66v-76.61c0-3.12,2.54-5.66,5.65-5.66h16.68c3.12,0,5.66,2.54,5.66,5.66v76.61c0,3.12-2.54,5.66-5.66,5.66ZM375.7,150.47c-2.29,0-4.15,1.86-4.15,4.16v76.61c0,2.29,1.86,4.16,4.15,4.16h16.68c2.29,0,4.16-1.86,4.16-4.16v-76.61c0-2.29-1.86-4.16-4.16-4.16h-16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M366.64,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2-3.78-4.18-3.07-.9.29-1.54,1.04-1.87,1.93-1.32.22-2.42.67-2.42,1.21v13.08c-.02,10.2-3.12,20.2-8.97,28.94l-16.1,24.03c-.23.73,2.15,1.47,5.02,2.1l-.61,1.05h-34.63c-3.12,0-5.65,2.6-5.65,5.8h0c0,2.99,2.21,5.49,5.11,5.78l18.61,1.85,4.82,38.6h22.92l-9.56-36.8,8.57.85c3.32.33,6.19-2.35,6.19-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.53-34.5c1.43-5.18,2.36-10.48,2.81-15.83h4.23v-3.44h-4.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 297.66,
    y: 148.97,
    width: 50.28,
    height: 47.9,
    rx: 10.3,
    ry: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M456.87,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2-3.78-4.18-3.07-.9.29-1.54,1.04-1.87,1.93-1.32.22-2.42.67-2.42,1.21v13.08c-.02,10.2-3.12,20.2-8.97,28.94l-16.1,24.03c-.23.73,2.15,1.47,5.02,2.1l-.61,1.05h-34.63c-3.12,0-5.65,2.6-5.65,5.8h0c0,2.99,2.21,5.49,5.11,5.78l18.61,1.85,4.82,38.6h22.92l-9.56-36.8,8.57.85c3.32.33,6.19-2.35,6.19-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.53-34.5c1.43-5.18,2.36-10.48,2.81-15.83h4.23v-3.44h-4.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 387.89,
    y: 148.97,
    width: 50.28,
    height: 47.9,
    rx: 10.3,
    ry: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M259.65,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2-3.78-4.18-3.07-.9.29-1.54,1.04-1.87,1.93-1.32.22-2.42.67-2.42,1.21v13.08c-.02,10.2-3.12,20.2-8.97,28.94l-16.1,24.03c-.23.73,2.15,1.47,5.02,2.1l-.61,1.05h-34.63c-3.12,0-5.65,2.6-5.65,5.8h0c0,2.99,2.21,5.49,5.11,5.78l18.61,1.85,4.82,38.6h22.92l-9.56-36.8,8.57.85c3.32.33,6.19-2.35,6.19-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.53-34.5c1.43-5.18,2.36-10.48,2.81-15.83h4.23v-3.44h-4.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 190.68,
    y: 148.97,
    width: 50.28,
    height: 47.9,
    rx: 10.3,
    ry: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M637.32,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2-3.78-4.18-3.07-.9.29-1.54,1.04-1.87,1.93-1.32.22-2.42.67-2.42,1.21v13.08c-.02,10.2-3.12,20.2-8.97,28.94l-16.1,24.03c-.23.73,2.15,1.47,5.02,2.1l-.61,1.05h-34.63c-3.12,0-5.65,2.6-5.65,5.8h0c0,2.99,2.21,5.49,5.11,5.78l18.61,1.85,4.82,38.6h22.92l-9.56-36.8,8.57.85c3.32.33,6.19-2.35,6.19-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.53-34.5c1.43-5.18,2.36-10.48,2.81-15.83h4.23v-3.44h-4.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 568.35,
    y: 148.97,
    width: 50.28,
    height: 47.9,
    rx: 10.3,
    ry: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M547.09,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2-3.78-4.18-3.07-.9.29-1.54,1.04-1.87,1.93-1.32.22-2.42.67-2.42,1.21v13.08c-.02,10.2-3.12,20.2-8.97,28.94l-16.1,24.03c-.23.73,2.15,1.47,5.02,2.1l-.61,1.05h-34.63c-3.12,0-5.65,2.6-5.65,5.8h0c0,2.99,2.21,5.49,5.11,5.78l18.61,1.85,4.82,38.6h22.92l-9.56-36.8,8.57.85c3.32.33,6.19-2.35,6.19-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.53-34.5c1.43-5.18,2.36-10.48,2.81-15.83h4.23v-3.44h-4.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 478.12,
    y: 148.97,
    width: 50.28,
    height: 47.9,
    rx: 10.3,
    ry: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M727.55,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2-3.78-4.18-3.07-.9.29-1.54,1.04-1.87,1.93-1.32.22-2.42.67-2.42,1.21v13.08c-.02,10.2-3.12,20.2-8.97,28.94l-16.1,24.03c-.23.73,2.15,1.47,5.02,2.1l-.61,1.05h-34.63c-3.12,0-5.65,2.6-5.65,5.8h0c0,2.99,2.21,5.49,5.11,5.78l18.61,1.85,4.82,38.6h22.92l-9.56-36.8,8.57.85c3.32.33,6.19-2.35,6.19-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.53-34.5c1.43-5.18,2.36-10.48,2.81-15.83h4.23v-3.44h-4.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 658.58,
    y: 148.97,
    width: 50.28,
    height: 47.9,
    rx: 10.3,
    ry: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M817.78,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2-3.78-4.18-3.07-.9.29-1.54,1.04-1.87,1.93-1.32.22-2.42.67-2.42,1.21v13.08c-.02,10.2-3.12,20.2-8.97,28.94l-16.1,24.03c-.23.73,2.15,1.47,5.02,2.1l-.61,1.05h-34.63c-3.12,0-5.65,2.6-5.65,5.8h0c0,2.99,2.21,5.49,5.11,5.78l18.61,1.85,4.82,38.6h22.92l-9.56-36.8,8.57.85c3.32.33,6.19-2.35,6.19-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.53-34.5c1.43-5.18,2.36-10.48,2.81-15.83h4.23v-3.44h-4.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 748.81,
    y: 148.97,
    width: 50.28,
    height: 47.9,
    rx: 10.3,
    ry: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M371.15,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2.01-3.78-4.19-3.07-.9.29-1.55,1.04-1.88,1.93-1.32.22-2.43.67-2.43,1.21v13.08c-.02,10.2-3.13,20.2-9,28.94l-16.15,24.03c-.23.73,2.16,1.47,5.03,2.1l-.62,1.05h-34.74c-3.13,0-5.67,2.6-5.67,5.8h0c0,2.99,2.22,5.49,5.12,5.78l18.67,1.85,4.84,38.6h22.99l-9.59-36.8,8.6.85c3.33.33,6.21-2.35,6.21-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.56-34.5c1.43-5.18,2.37-10.48,2.82-15.83h4.24v-3.44h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 301.95,
    y: 148.97,
    width: 50.44,
    height: 47.9,
    rx: 10.31,
    ry: 10.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M461.67,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2.01-3.78-4.19-3.07-.9.29-1.55,1.04-1.88,1.93-1.32.22-2.43.67-2.43,1.21v13.08c-.02,10.2-3.13,20.2-9,28.94l-16.15,24.03c-.23.73,2.16,1.47,5.03,2.1l-.62,1.05h-34.74c-3.13,0-5.67,2.6-5.67,5.8h0c0,2.99,2.22,5.49,5.12,5.78l18.67,1.85,4.84,38.6h22.99l-9.59-36.8,8.6.85c3.33.33,6.21-2.35,6.21-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.56-34.5c1.43-5.18,2.37-10.48,2.82-15.83h4.24v-3.44h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 392.47,
    y: 148.97,
    width: 50.44,
    height: 47.9,
    rx: 10.31,
    ry: 10.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M263.82,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2.01-3.78-4.19-3.07-.9.29-1.55,1.04-1.88,1.93-1.32.22-2.43.67-2.43,1.21v13.08c-.02,10.2-3.13,20.2-9,28.94l-16.15,24.03c-.23.73,2.16,1.47,5.03,2.1l-.62,1.05h-34.74c-3.13,0-5.67,2.6-5.67,5.8h0c0,2.99,2.22,5.49,5.12,5.78l18.67,1.85,4.84,38.6h22.99l-9.59-36.8,8.6.85c3.33.33,6.21-2.35,6.21-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.56-34.5c1.43-5.18,2.37-10.48,2.82-15.83h4.24v-3.44h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 194.62,
    y: 148.97,
    width: 50.44,
    height: 47.9,
    rx: 10.31,
    ry: 10.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M642.71,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2.01-3.78-4.19-3.07-.9.29-1.55,1.04-1.88,1.93-1.32.22-2.43.67-2.43,1.21v13.08c-.02,10.2-3.13,20.2-9,28.94l-16.15,24.03c-.23.73,2.16,1.47,5.03,2.1l-.62,1.05h-34.74c-3.13,0-5.67,2.6-5.67,5.8h0c0,2.99,2.22,5.49,5.12,5.78l18.67,1.85,4.84,38.6h22.99l-9.59-36.8,8.6.85c3.33.33,6.21-2.35,6.21-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.56-34.5c1.43-5.18,2.37-10.48,2.82-15.83h4.24v-3.44h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 573.51,
    y: 148.97,
    width: 50.44,
    height: 47.9,
    rx: 10.31,
    ry: 10.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M552.19,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2.01-3.78-4.19-3.07-.9.29-1.55,1.04-1.88,1.93-1.32.22-2.43.67-2.43,1.21v13.08c-.02,10.2-3.13,20.2-9,28.94l-16.15,24.03c-.23.73,2.16,1.47,5.03,2.1l-.62,1.05h-34.74c-3.13,0-5.67,2.6-5.67,5.8h0c0,2.99,2.22,5.49,5.12,5.78l18.67,1.85,4.84,38.6h22.99l-9.59-36.8,8.6.85c3.33.33,6.21-2.35,6.21-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.56-34.5c1.43-5.18,2.37-10.48,2.82-15.83h4.24v-3.44h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 482.99,
    y: 148.97,
    width: 50.44,
    height: 47.9,
    rx: 10.31,
    ry: 10.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M733.23,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2.01-3.78-4.19-3.07-.9.29-1.55,1.04-1.88,1.93-1.32.22-2.43.67-2.43,1.21v13.08c-.02,10.2-3.13,20.2-9,28.94l-16.15,24.03c-.23.73,2.16,1.47,5.03,2.1l-.62,1.05h-34.74c-3.13,0-5.67,2.6-5.67,5.8h0c0,2.99,2.22,5.49,5.12,5.78l18.67,1.85,4.84,38.6h22.99l-9.59-36.8,8.6.85c3.33.33,6.21-2.35,6.21-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.56-34.5c1.43-5.18,2.37-10.48,2.82-15.83h4.24v-3.44h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 664.03,
    y: 148.97,
    width: 50.44,
    height: 47.9,
    rx: 10.31,
    ry: 10.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M823.75,117.74c.06-1.26.09-2.53.09-3.79v-13.92c0-2.13-2.01-3.78-4.19-3.07-.9.29-1.55,1.04-1.88,1.93-1.32.22-2.43.67-2.43,1.21v13.08c-.02,10.2-3.13,20.2-9,28.94l-16.15,24.03c-.23.73,2.16,1.47,5.03,2.1l-.62,1.05h-34.74c-3.13,0-5.67,2.6-5.67,5.8h0c0,2.99,2.22,5.49,5.12,5.78l18.67,1.85,4.84,38.6h22.99l-9.59-36.8,8.6.85c3.33.33,6.21-2.35,6.21-5.78v-4.5c0-.87-.2-1.68-.53-2.42.27-.34.5-.71.63-1.16l9.56-34.5c1.43-5.18,2.37-10.48,2.82-15.83h4.24v-3.44h-4.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 754.55,
    y: 148.97,
    width: 50.44,
    height: 47.9,
    rx: 10.31,
    ry: 10.31
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M813.81,49.45H111.62c-15.31,0-30.27,18.54-42.15,52.21-10.25,29.08-17.18,67.38-18.08,99.96,0,.06.02.12.07.16.04.04.09.06.15.06,0,0,.02,0,.02,0l36.6-3.98c5.12-.56,10.01-2.08,14.54-4.53l58.6-31.66c15.93-8.61,33.92-13.16,52.03-13.16h58.5v106.39h109.94v-106.39h442.79c6.47,0,11.73-5.26,11.73-11.73,0-40.66-2.56-87.34-22.55-87.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M813.81,49.45H111.62c-15.31,0-30.27,18.54-42.15,52.21-10.25,29.08-17.18,67.38-18.08,99.96,0,.06.02.12.07.16.04.04.09.06.15.06,0,0,.02,0,.02,0l36.6-3.98c5.12-.56,10.01-2.08,14.54-4.53l58.6-31.66c15.93-8.61,33.92-13.16,52.03-13.16h58.5v106.39h109.94v-106.39h442.79c6.47,0,11.73-5.26,11.73-11.73,0-40.66-2.56-87.34-22.55-87.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M813.81,49.45H111.62c-15.31,0-30.27,18.54-42.15,52.21-10.25,29.08-17.18,67.38-18.08,99.96,0,.06.02.12.07.16.04.04.09.06.15.06,0,0,.02,0,.02,0l36.6-3.98c5.12-.56,10.01-2.08,14.54-4.53l58.6-31.66c15.93-8.61,33.92-13.16,52.03-13.16h58.5v106.39h109.94v-106.39h442.79c6.47,0,11.73-5.26,11.73-11.73,0-40.66-2.56-87.34-22.55-87.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M813.81,49.45H111.62c-15.31,0-30.27,18.54-42.15,52.21-10.25,29.08-17.18,67.38-18.08,99.96,0,.06.02.12.07.16.04.04.09.06.15.06,0,0,.02,0,.02,0l36.6-3.98c5.12-.56,10.01-2.08,14.54-4.53l58.6-31.66c15.93-8.61,33.92-13.16,52.03-13.16h58.5v106.39h109.94v-106.39h442.79c6.47,0,11.73-5.26,11.73-11.73,0-40.66-2.56-87.34-22.55-87.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M122.47,0h11.43c1.15,0,2.08.93,2.08,2.08v13.51h-15.59V2.08c0-1.15.93-2.08,2.08-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M133.4,7.43c0,2.88-2.34,5.22-5.22,5.22s-5.22-2.34-5.22-5.22,2.34-5.22,5.22-5.22,5.22,2.34,5.22,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.19,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 133.94,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.15,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 131.91,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.8,
    y: 2.77,
    width: 0.85,
    height: 8.88,
    rx: 0.32,
    ry: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 129.87,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.08,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 127.83,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.04,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 125.8,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.69,
    y: 2.77,
    width: 0.85,
    height: 8.88,
    rx: 0.32,
    ry: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 123.76,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.97,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 121.73,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 120.39,
    y: 13.55,
    width: 15.59,
    height: 2.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M119.63,15.89h17.1v3.61c0,1.2-.97,2.17-2.17,2.17h-12.77c-1.2,0-2.17-.97-2.17-2.17v-3.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M137.96,22.43h-19.56c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h19.56c.42,0,.76.34.76.76s-.34.76-.76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M133.45,39.51h-10.52c-1.82,0-3.3-1.48-3.3-3.3v-15.22c0-.38.31-.68.68-.68s.68.31.68.68v15.74c0,.78.63-.71,1.41-.71h11.58c.78,0,1.41,1.49,1.41.71v-15.74c0-.38.31-.68.68-.68s.68.31.68.68v15.22c0,1.82-1.48,3.3-3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M125.16,37.54c0,.46-.37.83-.83.83s-.83-.37-.83-.83.37-.83.83-.83.83.37.83.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 132.03,
    cy: 37.54,
    r: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M799.28,0h11.43c1.15,0,2.08.93,2.08,2.08v13.51h-15.59V2.08c0-1.15.93-2.08,2.08-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M810.22,7.43c0,2.88-2.34,5.22-5.22,5.22s-5.22-2.34-5.22-5.22,2.34-5.22,5.22-5.22,5.22,2.34,5.22,5.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 810.68,
    y: 2.77,
    width: 0.85,
    height: 8.88,
    rx: 0.32,
    ry: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 810.76,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M808.96,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 808.72,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M806.93,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 806.68,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M804.89,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 804.65,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.86,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 802.61,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 800.5,
    y: 2.77,
    width: 0.85,
    height: 8.88,
    rx: 0.32,
    ry: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 800.58,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M798.78,2.77h.21c.18,0,.32.14.32.32v8.24c0,.18-.14.32-.32.32h-.21c-.18,0-.32-.14-.32-.32V3.09c0-.18.14-.32.32-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 798.54,
    y: 2.95,
    width: 0.57,
    height: 2.52,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 797.2,
    y: 13.55,
    width: 15.59,
    height: 2.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M796.45,15.89h17.1v3.61c0,1.2-.97,2.17-2.17,2.17h-12.77c-1.2,0-2.17-.97-2.17-2.17v-3.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M814.77,22.43h-19.56c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h19.56c.42,0,.76.34.76.76s-.34.76-.76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M810.26,39.51h-10.52c-1.82,0-3.3-1.48-3.3-3.3v-15.22c0-.38.31-.68.68-.68s.68.31.68.68v15.74c0,.78.63-.71,1.41-.71h11.58c.78,0,1.41,1.49,1.41.71v-15.74c0-.38.31-.68.68-.68s.68.31.68.68v15.22c0,1.82-1.48,3.3-3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 801.15,
    cy: 37.54,
    r: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M809.67,37.54c0,.46-.37.83-.83.83s-.83-.37-.83-.83.37-.83.83-.83.83.37.83.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M828.26,19.57H109.6c-14.55,0-35.94,4.49-43.36,12.7-5.99,6.63-11.49,15.08-16.47,24.82h8.06c4.32,0,7.2,4.44,5.42,8.38-15.3,33.91-25.07,80.05-28.67,120.71-.27,3.09-2.83,5.46-5.93,5.46h-12.03c-3.44,45.42,1.08,82.76,14.52,86.3h70.55c1.34,0,2.43-1.09,2.43-2.43v-5.06c0-26.65,21.61-48.26,48.26-48.26s48.26,21.61,48.26,48.26v5.06c0,1.34,1.09,2.43,2.43,2.43h381.2c1.34,0,2.43-1.09,2.43-2.43v-5.06c0-26.65,21.61-48.26,48.26-48.26s48.26,21.61,48.26,48.26v5.06c0,1.34,1.09,2.43,2.43,2.43h40.49c24.74,0,103.94-3.58,132.45-14.37,2.86-1.08,4.76-3.81,4.76-6.87v-53.11c0-112.11-15.04-184.01-35.09-184.01ZM824.16,148.52h-444.97v107.22h-103.98v-107.22h-61.8c-18.1,0-36.1,4.55-52.03,13.16l-58.6,31.66c-4.53,2.45-9.42,3.97-14.54,4.53l-36.6,3.98s-.02,0-.02,0c-.05,0-.11-.02-.15-.06-.05-.04-.07-.1-.07-.16.9-32.58,7.83-70.88,18.08-99.96,11.87-33.67,26.84-52.21,42.15-52.21h701.71c19.99,0,22.55,46.68,22.55,87.34,0,6.47-5.26,11.73-11.73,11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M209.54,212.42c-7.59,0-15.04-2.83-21.3-8.31-9-7.87-19.88-12.48-31.61-12.48h-8.5c-11.73,0-22.61,4.61-31.61,12.48-6.26,5.48-13.71,8.31-21.3,8.31H15.6c-.06,2.68-.09,5.31-.08,7.88h259.69v-7.88h-65.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M863.34,212.42h-171.41c-7.59,0-15.04-2.83-21.3-8.31-9-7.87-19.88-12.48-31.61-12.48h-8.5c-11.73,0-22.61,4.61-31.61,12.48-6.26,5.48-13.71,8.31-21.3,8.31h-198.43v7.88h484.16v-7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M691.94,214.13c-7.59,0-15.04-2.21-21.3-6.5-9-6.16-19.88-9.76-31.61-9.76h-8.5c-11.73,0-22.61,3.6-31.61,9.76-6.26,4.29-13.71,6.5-21.3,6.5h-198.43v41.62h-103.98v-41.62h-65.66c-7.59,0-15.04-2.21-21.3-6.5-9-6.16-19.88-9.76-31.61-9.76h-8.5c-11.73,0-22.61,3.6-31.61,9.76-6.26,4.29-13.71,6.5-21.3,6.5H15.56c-.57,34.72,4.44,60.87,15.58,63.8h70.55c1.34,0,2.43-1.09,2.43-2.43v-4.06c0-26.3,20.62-48.53,46.9-49.25,27.27-.75,49.62,21.14,49.62,48.24v5.06c0,1.34,1.09,2.43,2.43,2.43h381.2c1.34,0,2.43-1.09,2.43-2.43v-4.06c0-26.3,20.62-48.53,46.9-49.25,27.27-.75,49.62,21.14,49.62,48.24v5.06c0,1.34,1.09,2.43,2.43,2.43h40.49c24.74,0,103.94-3.58,132.45-14.37,2.86-1.08,4.76-3.81,4.76-6.87v-42.56h-171.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M22.13,268c2.36,5.47,5.35,8.97,9.02,9.93h70.55c1.34,0,2.43-1.09,2.43-2.43v-5.06c0-.82.02-1.64.06-2.45H22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M200.58,268c.04.81.06,1.63.06,2.45v5.06c0,1.34,1.09,2.43,2.43,2.43h381.2c1.34,0,2.43-1.09,2.43-2.43v-5.06c0-.82.02-1.64.06-2.45H200.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M702.02,268h-18.87c.04.81.06,1.63.06,2.45v5.06c0,1.34,1.09,2.43,2.43,2.43h40.49c24.77,0,104.1-3.58,132.54-14.41,2.51-.96,4.24-3.22,4.6-5.84-28.86,6.11-78.59,10.31-161.24,10.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M691.94,214.13c-7.59,0-15.04-2.21-21.3-6.5-9-6.16-19.88-9.76-31.61-9.76h-8.5c-11.73,0-22.61,3.6-31.61,9.76-6.26,4.29-13.71,6.5-21.3,6.5h-198.43v7.57h198.43c7.59,0,15.04-1.91,21.3-5.6,9-5.31,19.88-8.42,31.61-8.42h8.5c11.73,0,22.61,3.11,31.61,8.42,6.26,3.7,13.71,5.6,21.3,5.6h171.41v-7.57h-171.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M209.54,214.13c-7.59,0-15.04-2.21-21.3-6.5-9-6.16-19.88-9.76-31.61-9.76h-8.5c-11.73,0-22.61,3.6-31.61,9.76-6.26,4.29-13.71,6.5-21.3,6.5H15.56c-.04,2.58-.05,5.1-.03,7.57h79.69c7.59,0,15.04-1.91,21.3-5.6,9-5.31,19.88-8.42,31.61-8.42h8.5c11.73,0,22.61,3.11,31.61,8.42,6.26,3.7,13.71,5.6,21.3,5.6h65.66v-7.57h-65.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 271.9,
    y: 57.27,
    width: 110.4,
    height: 210.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M271.9,57.27v210.72h55.2V57.27h-55.2ZM322.18,244.52c0,2.91-2.36,5.27-5.27,5.27h-34.83c-2.91,0-5.26-2.36-5.26-5.27v-47.63c0-2.91,2.36-5.27,5.26-5.27h34.83c2.91,0,5.27,2.36,5.27,5.27v47.63ZM322.18,155.31c0,4.1-3.32,7.42-7.42,7.42h-30.51c-4.1,0-7.42-3.32-7.42-7.42v-69c0-5.87,4.76-10.63,10.63-10.63h24.11c5.87,0,10.63,4.76,10.63,10.63v69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M327.1,57.27v210.72h55.2V57.27h-55.2ZM377.38,244.52c0,2.91-2.36,5.27-5.27,5.27h-34.83c-2.91,0-5.26-2.36-5.26-5.27v-47.63c0-2.91,2.36-5.27,5.26-5.27h34.83c2.91,0,5.27,2.36,5.27,5.27v47.63ZM377.38,155.31c0,4.1-3.32,7.42-7.42,7.42h-30.51c-4.1,0-7.42-3.32-7.42-7.42v-69c0-5.87,4.76-10.63,10.63-10.63h24.11c5.87,0,10.63,4.76,10.63,10.63v69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M381.67,57.57h-53.95c-.35,0-.63.29-.63.64,0-.35-.28-.64-.63-.64h-53.95c-.35,0-.63.29-.63.64v209.79h1.25V58.84h52.69v209.15h2.51V58.84h52.69v209.15h1.25V58.21c0-.35-.28-.64-.63-.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M828.26,19.57H109.6c-14.55,0-35.94,4.49-43.36,12.7-5.99,6.63-11.49,15.08-16.47,24.82h8.06c4.32,0,7.2,4.44,5.42,8.38-15.3,33.91-25.07,80.05-28.67,120.71-.27,3.09-2.83,5.46-5.93,5.46h-12.03c-3.44,45.42,1.08,82.76,14.52,86.3h70.55c1.34,0,2.43-1.09,2.43-2.43v-5.06c0-26.65,21.61-48.26,48.26-48.26s48.26,21.61,48.26,48.26v5.06c0,1.34,1.09,2.43,2.43,2.43h381.2c1.34,0,2.43-1.09,2.43-2.43v-5.06c0-26.65,21.61-48.26,48.26-48.26s48.26,21.61,48.26,48.26v5.06c0,1.34,1.09,2.43,2.43,2.43h40.49c24.74,0,103.94-3.58,132.45-14.37,2.86-1.08,4.76-3.81,4.76-6.87v-53.11c0-112.11-15.04-184.01-35.09-184.01ZM282.08,191.63h34.83c2.91,0,5.27,2.36,5.27,5.27v47.63c0,2.91-2.36,5.27-5.27,5.27h-34.83c-2.91,0-5.26-2.36-5.26-5.27v-47.63c0-2.91,2.36-5.27,5.26-5.27ZM276.82,155.31v-69c0-5.87,4.76-10.63,10.63-10.63h24.11c5.87,0,10.63,4.76,10.63,10.63v69c0,4.1-3.32,7.42-7.42,7.42h-30.51c-4.1,0-7.42-3.32-7.42-7.42ZM337.28,191.63h34.83c2.91,0,5.27,2.36,5.27,5.27v47.63c0,2.91-2.36,5.27-5.27,5.27h-34.83c-2.91,0-5.26-2.36-5.26-5.27v-47.63c0-2.91,2.36-5.27,5.26-5.27ZM332.02,155.31v-69c0-5.87,4.76-10.63,10.63-10.63h24.11c5.87,0,10.63,4.76,10.63,10.63v69c0,4.1-3.32,7.42-7.42,7.42h-30.51c-4.1,0-7.42-3.32-7.42-7.42ZM161.37,161.68l-58.6,31.66c-4.53,2.45-9.42,3.97-14.54,4.53l-36.6,3.98s-.02,0-.02,0c-.05,0-.11-.02-.15-.06-.05-.04-.07-.1-.07-.16.9-32.58,7.83-70.88,18.08-99.96,11.87-33.67,26.84-52.21,42.15-52.21h160.28v99.07h-58.5c-18.1,0-36.1,4.55-52.03,13.16ZM824.16,148.52h-441.86V49.45h431.04c19.99,0,22.55,46.68,22.55,87.34,0,6.47-5.26,11.73-11.73,11.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 219.41,
    y: 166.7,
    width: 53.13,
    height: 21.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 381.66,
    y: 166.7,
    width: 385.8,
    height: 21.96
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M210.65,152.42c-27.54,0-52.23,15.08-50.99,14.69,15.97-5.04,26.79-6.59,41.86-6.59h71.02v-8.1h-61.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M381.84,152.42v8.1h399.45c4.47,0,45.46-3.63,45.46-8.1h-444.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M836.85,136.54c0-.24-.19-.43-.43-.43s-.43.19-.43.43v132.71l.86-.15v-132.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M666.89,234.27c2.34,2.07,4.47,4.35,6.37,6.83h190.08v-6.83h-196.45ZM190.69,241.1h81.85v-6.83h-88.22c2.34,2.07,4.47,4.35,6.37,6.83ZM381.84,241.1h214.8c1.9-2.48,4.04-4.76,6.37-6.83h-221.18v6.83ZM50.64,241.1h63.43c1.9-2.48,4.04-4.76,6.37-6.83H50.64v6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M839.43,220.05v21.05h23.91v-26.97h-17.99c-3.27,0-5.92,2.65-5.92,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M840.53,220.43v16.32c0,.97.79,1.77,1.77,1.77h21.05v-22.97h-17.94c-2.69,0-4.88,2.18-4.88,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M17.72,251.52h33.78v-6.83H16.79c.27,2.38.58,4.66.93,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M51.5,214.13H15.56c-.2,12.03.28,23.02,1.45,32.38h34.49v-32.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M15.55,215.95c-.11,10.56.3,20.27,1.26,28.74h6.13v-28.74h-7.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 22.94,
    y: 215.95,
    width: 26.57,
    height: 28.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.9,
    y: 236.2,
    width: 1.23,
    height: 8.08,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(49.03 480.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 24.2,
    y: 236.44,
    width: 0.82,
    height: 5.39,
    rx: 0.29,
    ry: 0.29,
    transform: "translate(49.22 478.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.54,
    y: 236.2,
    width: 1.23,
    height: 8.08,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(52.31 480.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 25.84,
    y: 236.44,
    width: 0.82,
    height: 5.39,
    rx: 0.29,
    ry: 0.29,
    transform: "translate(52.51 478.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.18,
    y: 236.2,
    width: 1.23,
    height: 8.08,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(55.6 480.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 27.48,
    y: 236.44,
    width: 0.82,
    height: 5.39,
    rx: 0.29,
    ry: 0.29,
    transform: "translate(55.79 478.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.82,
    y: 236.2,
    width: 1.23,
    height: 8.08,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(58.88 480.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 29.13,
    y: 236.44,
    width: 0.82,
    height: 5.39,
    rx: 0.29,
    ry: 0.29,
    transform: "translate(59.07 478.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.46,
    y: 236.2,
    width: 1.23,
    height: 8.08,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(62.16 480.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 30.77,
    y: 236.44,
    width: 0.82,
    height: 5.39,
    rx: 0.29,
    ry: 0.29,
    transform: "translate(62.35 478.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 23.9,
    y: 226.05,
    width: 1.23,
    height: 9.13,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(49.03 461.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 24.2,
    y: 226.33,
    width: 0.82,
    height: 6.09,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(49.22 458.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 25.54,
    y: 226.05,
    width: 1.23,
    height: 9.13,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(52.31 461.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 25.84,
    y: 226.33,
    width: 0.82,
    height: 6.09,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(52.51 458.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 27.18,
    y: 226.05,
    width: 1.23,
    height: 9.13,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(55.6 461.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 27.48,
    y: 226.33,
    width: 0.82,
    height: 6.09,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(55.79 458.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 28.82,
    y: 226.05,
    width: 1.23,
    height: 9.13,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(58.88 461.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 29.12,
    y: 226.33,
    width: 0.82,
    height: 6.09,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(59.07 458.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 30.46,
    y: 226.05,
    width: 1.23,
    height: 9.13,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(62.16 461.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 30.77,
    y: 226.33,
    width: 0.82,
    height: 6.09,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(62.35 458.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 32.38,
    y: 226.05,
    width: 1.08,
    height: 8.15,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(65.84 460.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 32.65,
    y: 226.3,
    width: 0.72,
    height: 5.43,
    rx: 0.28,
    ry: 0.28,
    transform: "translate(66.01 458.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 33.82,
    y: 226.05,
    width: 1.08,
    height: 6.82,
    rx: 0.39,
    ry: 0.39,
    transform: "translate(68.73 458.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 34.09,
    y: 226.26,
    width: 0.72,
    height: 4.54,
    rx: 0.26,
    ry: 0.26,
    transform: "translate(68.9 457.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 35.27,
    y: 226.05,
    width: 1.08,
    height: 5.25,
    rx: 0.34,
    ry: 0.34,
    transform: "translate(71.61 457.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 35.53,
    y: 226.21,
    width: 0.72,
    height: 3.5,
    rx: 0.23,
    ry: 0.23,
    transform: "translate(71.78 455.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 36.71,
    y: 226.05,
    width: 1.08,
    height: 3.65,
    rx: 0.28,
    ry: 0.28,
    transform: "translate(74.5 455.76) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 36.97,
    y: 226.16,
    width: 0.72,
    height: 2.44,
    rx: 0.19,
    ry: 0.19,
    transform: "translate(74.67 454.76) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M38.39,226.06h.61c.13,0,.24.11.24.24v2.07c0,.13-.11.24-.24.24h-.61c-.13,0-.24-.11-.24-.24v-2.07c0-.13.11-.24.24-.24Z",
    transform: "translate(77.38 454.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 38.41,
    y: 226.13,
    width: 0.72,
    height: 1.7,
    rx: 0.16,
    ry: 0.16,
    transform: "translate(77.55 453.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 23.9,
    y: 216.38,
    width: 1.29,
    height: 9.13,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(49.1 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 24.22,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(49.3 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 25.63,
    y: 216.38,
    width: 1.29,
    height: 9.13,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(52.55 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 25.94,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(52.75 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M27.85,216.38h.31c.27,0,.49.22.49.49v8.15c0,.27-.22.49-.49.49h-.31c-.27,0-.49-.22-.49-.49v-8.15c0-.27.22-.49.49-.49Z",
    transform: "translate(56 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 27.67,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(56.21 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 29.08,
    y: 216.38,
    width: 1.29,
    height: 9.13,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(59.46 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 29.4,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(59.66 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M31.3,216.38h.31c.27,0,.49.22.49.49v8.15c0,.27-.22.49-.49.49h-.31c-.27,0-.49-.22-.49-.49v-8.15c0-.27.22-.49.49-.49Z",
    transform: "translate(62.91 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 31.12,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(63.11 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 32.78,
    y: 216.38,
    width: 1.29,
    height: 9.13,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(66.85 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 33.09,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(67.05 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 34.5,
    y: 216.38,
    width: 1.29,
    height: 9.13,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(70.3 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 34.82,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(70.51 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M36.72,216.38h.31c.27,0,.49.22.49.49v8.15c0,.27-.22.49-.49.49h-.31c-.27,0-.49-.22-.49-.49v-8.15c0-.27.22-.49.49-.49Z",
    transform: "translate(73.76 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 36.55,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(73.96 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 37.96,
    y: 216.38,
    width: 1.29,
    height: 9.13,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(77.21 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 38.27,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(77.41 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M40.18,216.38h.31c.27,0,.49.22.49.49v8.15c0,.27-.22.49-.49.49h-.31c-.27,0-.49-.22-.49-.49v-8.15c0-.27.22-.49.49-.49Z",
    transform: "translate(80.66 441.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 40,
    y: 216.65,
    width: 0.86,
    height: 6.09,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(80.87 439.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "48.75 244.27 32.38 244.27 32.38 236.2 41.63 226.33 41.63 216.38 48.75 216.38 48.75 244.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 41.63,
    y: 216.38,
    width: 7.13,
    height: 5.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M19.8,225.17c0,2.97,1.34,5.45,3.14,6.13v-12.26c-1.8.68-3.14,3.16-3.14,6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M21.11,237c0,1.92.78,3.53,1.83,3.97v-7.94c-1.05.44-1.83,2.05-1.83,3.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 15.88,
    y: 216.38,
    width: 1.01,
    height: 13.74,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(32.77 446.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 16.13,
    y: 216.79,
    width: 0.68,
    height: 9.16,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(32.93 442.74) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 17.23,
    y: 216.38,
    width: 1.01,
    height: 13.74,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(35.47 446.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 17.48,
    y: 216.79,
    width: 0.68,
    height: 9.16,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(35.63 442.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 18.58,
    y: 216.38,
    width: 1.01,
    height: 13.74,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(38.17 446.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 18.83,
    y: 216.79,
    width: 0.68,
    height: 9.16,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(38.33 442.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 19.93,
    y: 216.38,
    width: 1.01,
    height: 13.74,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(40.88 446.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 20.18,
    y: 216.79,
    width: 0.68,
    height: 9.16,
    rx: 0.33,
    ry: 0.33,
    transform: "translate(41.03 442.74) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M21.76,219.24h.06c.26,0,.48.21.48.48v9.93c0,.26-.21.48-.48.48h-.06c-.26,0-.48-.21-.48-.48v-9.93c0-.26.21-.48.48-.48Z",
    transform: "translate(43.58 449.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 21.53,
    y: 219.56,
    width: 0.68,
    height: 7.25,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(43.74 446.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 17.07,
    y: 230.52,
    width: 0.83,
    height: 13.74,
    rx: 0.41,
    ry: 0.41,
    transform: "translate(34.96 474.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 17.27,
    y: 230.94,
    width: 0.55,
    height: 9.16,
    rx: 0.27,
    ry: 0.27,
    transform: "translate(35.09 471.03) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 18.17,
    y: 230.52,
    width: 0.83,
    height: 13.74,
    rx: 0.41,
    ry: 0.41,
    transform: "translate(37.16 474.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 18.37,
    y: 230.94,
    width: 0.55,
    height: 9.16,
    rx: 0.27,
    ry: 0.27,
    transform: "translate(37.29 471.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 19.27,
    y: 230.52,
    width: 0.83,
    height: 13.74,
    rx: 0.41,
    ry: 0.41,
    transform: "translate(39.36 474.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 19.47,
    y: 230.94,
    width: 0.55,
    height: 9.16,
    rx: 0.27,
    ry: 0.27,
    transform: "translate(39.49 471.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 20.37,
    y: 230.52,
    width: 0.83,
    height: 13.74,
    rx: 0.41,
    ry: 0.41,
    transform: "translate(41.56 474.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 20.57,
    y: 230.94,
    width: 0.55,
    height: 9.16,
    rx: 0.27,
    ry: 0.27,
    transform: "translate(41.69 471.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 21.47,
    y: 231.96,
    width: 0.83,
    height: 10.88,
    rx: 0.41,
    ry: 0.41,
    transform: "translate(43.77 474.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 21.67,
    y: 232.28,
    width: 0.55,
    height: 7.25,
    rx: 0.27,
    ry: 0.27,
    transform: "translate(43.9 471.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M842.41,237.35h16.63v-2.48l-9.4-9.21v-9.28h-3.07c-2.3,0-4.17,1.87-4.17,4.17v16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M842.41,216.38h7.24v2.17c0,1.74-1.41,3.16-3.16,3.16h-4.08v-5.32h0Z",
    transform: "translate(1692.07 438.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.14,21.28h712.65c0,10.71-8.69,19.4-19.4,19.4H128.54c-10.71,0-19.4-8.69-19.4-19.4h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M228.11,257.27h9.95c.52,0,.94.42.94.94v5.48c0,.52-.42.94-.94.94h-9.95c-.52,0-.94-.42-.94-.94v-5.48c0-.52.42-.94.94-.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 227.82,
    y: 257.81,
    width: 10.53,
    height: 6.28,
    rx: 1.33,
    ry: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 236.71,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 236.82,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 235.02,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 235.13,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 233.32,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 233.43,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.62,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 231.73,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.93,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 230.04,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 228.23,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 228.34,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M482.64,257.27h9.95c.52,0,.94.42.94.94v5.48c0,.52-.42.94-.94.94h-9.95c-.52,0-.94-.42-.94-.94v-5.48c0-.52.42-.94.94-.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 482.35,
    y: 257.81,
    width: 10.53,
    height: 6.28,
    rx: 1.33,
    ry: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 491.24,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 491.35,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 489.54,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M489.85,258.51h.44c.11,0,.19.09.19.19v1.06c0,.11-.09.19-.19.19h-.44c-.11,0-.19-.09-.19-.19v-1.06c0-.11.09-.19.19-.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.85,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 487.95,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 486.15,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 486.26,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 484.45,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 484.56,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 482.76,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 482.86,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M755.04,257.27h9.95c.52,0,.94.42.94.94v5.48c0,.52-.42.94-.94.94h-9.95c-.52,0-.94-.42-.94-.94v-5.48c0-.52.42-.94.94-.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 754.75,
    y: 257.81,
    width: 10.53,
    height: 6.28,
    rx: 1.33,
    ry: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 763.64,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 763.75,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 761.94,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 762.05,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 760.25,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 760.35,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 758.55,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 758.66,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 756.85,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 756.96,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 755.16,
    y: 258.41,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 755.26,
    y: 258.51,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M102.66,19.88c-6.59,2.28-12.18,5.28-15.22,8.89-19.21,22.79-35.4,68.52-44.42,125.46-2.68,16.91-4.5,33.74-5.48,49.54h.31c3.96-62.85,21.69-141.24,49.92-174.73,3.23-3.83,9.37-6.99,16.54-9.29-.54.04-1.09.08-1.65.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M813.81,49.45H111.62c-15.31,0-30.27,18.54-42.15,52.21-10.25,29.08-17.18,67.38-18.08,99.96,0,.06.02.12.07.16.04.04.09.06.15.06,0,0,.02,0,.02,0l36.6-3.98c5.12-.56,10.01-2.08,14.54-4.53l58.6-31.66c15.93-8.61,33.92-13.16,52.03-13.16h59.14v-83.74h109.12v83.74h442.97c6.47,0,11.73-5.26,11.73-11.73,0-40.66-2.56-87.34-22.55-87.34ZM153.11,157.45l-52.07,27.84c-4.31,2.3-9.04,3.7-13.91,4.11l-18.41,1.54c-8.96,1.21-5.63-23.9-3.54-35.93.63-3.62,3.77-6.25,7.44-6.25h78.19c4.78,0,6.45,6.34,2.3,8.7ZM196.27,140.82H68.01s19.76-83.73,49.07-83.73h79.19v83.73ZM258.53,140.82h-53.64V57.09h53.64v83.73ZM556.21,140.82h-160.54V57.09h160.54v83.73ZM726.08,140.82h-160.56V57.09h160.56v83.73ZM817.41,140.82h-82.71V57.09h70.16c17.54,0,20.93,83.73,12.55,83.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M813.65,48.81H111.94c-34.1,0-59.11,88.8-60.87,152.91l-35,3.81c-.23.03-.4.24-.38.47.02.22.21.38.42.38.02,0,.03,0,.05,0l34.88-3.8c-.05,2.1-.08,4.18-.08,6.23v69.12h.86v-69.12c0-2.08.03-4.18.08-6.32l36.71-4c5.18-.56,10.2-2.13,14.78-4.6l58.6-31.66c15.89-8.58,33.66-13.08,51.72-13.08h58.82v-.86h-58.82c-18.14,0-36.17,4.56-52.13,13.18l-58.6,31.66c-4.48,2.42-9.39,3.95-14.46,4.5l-36.6,3.99c1.77-63.76,26.42-151.97,60.02-151.97h701.71c19.8,0,22.34,46.56,22.34,87.12,0,6.36-5.16,11.52-11.52,11.52h-442.5v.86h443.36c6.36,0,11.51-5.16,11.51-11.52v-.86c0-40.96-2.64-87.98-23.19-87.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M271.26,268h111.68v.02c0,3.48-2.83,6.31-6.31,6.31h-99.07c-3.48,0-6.31-2.83-6.31-6.31v-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M854.47,216.38h4.1c2.63,0,4.77,2.14,4.77,4.77v.71c0,2.63-2.14,4.77-4.77,4.77h-4.1c-1.21,0-2.19-.98-2.19-2.19v-5.87c0-1.21.98-2.19,2.19-2.19Z",
    transform: "translate(1715.63 443) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 860.72,
    y: 217.14,
    width: 1.65,
    height: 8.71,
    rx: 0.44,
    ry: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 860.87,
    y: 217.32,
    width: 1.1,
    height: 2.48,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 858.46,
    y: 217.14,
    width: 1.65,
    height: 8.71,
    rx: 0.44,
    ry: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 858.6,
    y: 217.32,
    width: 1.1,
    height: 2.48,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 856.19,
    y: 217.14,
    width: 1.65,
    height: 8.71,
    rx: 0.44,
    ry: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 856.33,
    y: 217.32,
    width: 1.1,
    height: 2.48,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M853.96,227.6h4.96c2.44,0,4.42,1.98,4.42,4.42v1.41c0,2.44-1.98,4.42-4.42,4.42h-4.96c-1.12,0-2.03-.91-2.03-2.03v-6.2c0-1.12.91-2.03,2.03-2.03Z",
    transform: "translate(1715.28 465.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 860.64,
    y: 228.37,
    width: 1.71,
    height: 8.72,
    rx: 0.45,
    ry: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M861.09,228.54h.54c.17,0,.3.13.3.3v1.88c0,.17-.13.3-.3.3h-.54c-.17,0-.3-.13-.3-.3v-1.88c0-.17.13-.3.3-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 858.3,
    y: 228.37,
    width: 1.71,
    height: 8.72,
    rx: 0.45,
    ry: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M858.75,228.54h.54c.17,0,.3.13.3.3v1.88c0,.17-.13.3-.3.3h-.54c-.17,0-.3-.13-.3-.3v-1.88c0-.17.13-.3.3-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.96,
    y: 228.37,
    width: 1.71,
    height: 8.72,
    rx: 0.45,
    ry: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 856.11,
    y: 228.54,
    width: 1.14,
    height: 2.48,
    rx: 0.3,
    ry: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M49.84,145.07c-8.15,5.86-16.31,11.72-24.46,17.58.07-.46.13-.93.13-1.42,0-3.42-1.78-6.35-4.34-7.75-1.08,6.71-2,13.4-2.77,20,11.19-8.54,22.39-17.08,33.58-25.63.96-.73,1.25-1.93.68-2.69-.57-.76-1.82-.81-2.8-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M18.39,143.46c-.23.07-.48.1-.72.08-1.04-.07-1.76-.88-1.62-1.82,1.19-7.8-3.91-13.74-3.96-13.8-.62-.71-.45-1.79.38-2.4.84-.62,2.02-.54,2.65.18.25.28,6.1,7.02,4.69,16.26-.11.71-.69,1.29-1.41,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M13.23,126.24c-.25-.28-.59-.43-.95-.51-.64.63-.75,1.55-.19,2.2.05.06,2.21,4.43,3.96,13.8.16.85.47,1.57,1.35,1.75.27-.27.46-.6.51-.97,1.41-9.24-4.44-15.98-4.68-16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M51.84,147.69H18.59c-8.86,0-16.06-7.21-16.06-16.06v-30.47c0-.95.77-1.71,1.71-1.71s1.71.77,1.71,1.71v30.47c0,6.97,5.67,12.64,12.64,12.64h33.25c.95,0,1.71.77,1.71,1.71s-.77,1.71-1.71,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M13.88,103.91c0,10.65-1.36,19.28-3.04,19.28s-3.04-8.63-3.04-19.28,1.36-19.28,3.04-19.28,3.04,8.63,3.04,19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M11.08,84.12h.63v39.59h-.63c-2.22,0-4.02-1.8-4.02-4.02v-31.55c0-2.22,1.8-4.02,4.02-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M7.06,87.97h.13c.85,0,1.54.69,1.54,1.54v28.8c0,.85-.69,1.54-1.54,1.54h-.13v-31.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M7.8,115.34H3.74c-2.24,0-3.98-1.54-3.72-3.3l2.57-17.61c.22-1.49,1.82-2.62,3.72-2.62h1.48v23.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 4.24,
    y: 131.63,
    width: 11.21,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M65.9,32.66c-5.86,6.57-11.24,14.88-16.12,24.43-.03.06-.06.13-.09.19h3.76c4.03,0,6.73,4.15,5.07,7.82-11.19,24.66-19.44,55.87-24.5,86.74-.44,2.69-2.75,4.68-5.48,4.68h-7.85c-1.84,11.94-3.19,23.79-4.05,35.13-.37,4.88-.66,9.68-.84,14.35l21.95-2.4c3.79-60.32,20.05-135.25,46.9-170.92h-18.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M53.45,57.27h-3.76c-13.71,26.85-23.51,63.5-29,99.23h7.85c2.73,0,5.04-1.98,5.48-4.68,5.06-30.87,13.31-62.07,24.5-86.74,1.66-3.67-1.04-7.82-5.07-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M716.76,232.37h-7.33c-2.29,0-4.15-1.86-4.15-4.15v-8.84c0-2.29,1.86-4.15,4.15-4.15h12.87c2.29,0,4.15,1.86,4.15,4.15v3.3c0,5.34-4.35,9.69-9.69,9.69ZM709.43,215.59c-2.09,0-3.79,1.7-3.79,3.79v8.84c0,2.09,1.7,3.78,3.79,3.78h7.33c5.14,0,9.33-4.18,9.33-9.33v-3.3c0-2.09-1.7-3.79-3.79-3.79h-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M228.11,36.91h9.95c.52,0,.94.42.94.94v5.48c0,.52-.42.94-.94.94h-9.95c-.52,0-.94-.42-.94-.94v-5.48c0-.52.42-.94.94-.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 227.82,
    y: 37.44,
    width: 10.53,
    height: 6.28,
    rx: 1.33,
    ry: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 236.71,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 236.82,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 235.02,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 235.13,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 233.32,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 233.43,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.62,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 231.73,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.93,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 230.04,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 228.23,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 228.34,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M755.04,36.91h9.95c.52,0,.94.42.94.94v5.48c0,.52-.42.94-.94.94h-9.95c-.52,0-.94-.42-.94-.94v-5.48c0-.52.42-.94.94-.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 754.75,
    y: 37.44,
    width: 10.53,
    height: 6.28,
    rx: 1.33,
    ry: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 763.64,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 763.75,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 761.94,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 762.05,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 760.25,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 760.35,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 758.55,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 758.66,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 756.85,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 756.96,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 755.16,
    y: 38.04,
    width: 1.24,
    height: 5.09,
    rx: 0.29,
    ry: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 755.26,
    y: 38.14,
    width: 0.82,
    height: 1.45,
    rx: 0.19,
    ry: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M316.91,250.22h-34.83c-3.14,0-5.69-2.55-5.69-5.69v-47.63c0-3.14,2.55-5.69,5.69-5.69h34.83c3.14,0,5.69,2.55,5.69,5.69v47.63c0,3.14-2.55,5.69-5.69,5.69ZM282.08,192.06c-2.67,0-4.84,2.17-4.84,4.84v47.63c0,2.67,2.17,4.84,4.84,4.84h34.83c2.67,0,4.84-2.17,4.84-4.84v-47.63c0-2.67-2.17-4.84-4.84-4.84h-34.83ZM314.75,163.16h-30.51c-4.33,0-7.85-3.52-7.85-7.85v-69.01c0-6.1,4.96-11.06,11.06-11.06h24.1c6.1,0,11.06,4.96,11.06,11.06v69.01c0,4.33-3.52,7.85-7.85,7.85ZM287.44,76.1c-5.62,0-10.2,4.58-10.2,10.2v69.01c0,3.86,3.14,7,7,7h30.51c3.86,0,7-3.14,7-7v-69.01c0-5.62-4.57-10.2-10.2-10.2h-24.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M272.54,57.92h53.92v210.08h1.28V57.27c0-.35-.29-.64-.64-.64h-55.2c-.35,0-.64.29-.64.64v210.72h1.28V57.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M372.11,250.22h-34.83c-3.14,0-5.69-2.55-5.69-5.69v-47.63c0-3.14,2.55-5.69,5.69-5.69h34.83c3.14,0,5.69,2.55,5.69,5.69v47.63c0,3.14-2.55,5.69-5.69,5.69ZM337.28,192.06c-2.67,0-4.84,2.17-4.84,4.84v47.63c0,2.67,2.17,4.84,4.84,4.84h34.83c2.67,0,4.84-2.17,4.84-4.84v-47.63c0-2.67-2.17-4.84-4.84-4.84h-34.83ZM369.95,163.16h-30.51c-4.33,0-7.85-3.52-7.85-7.85v-69.01c0-6.1,4.96-11.06,11.06-11.06h24.1c6.1,0,11.06,4.96,11.06,11.06v69.01c0,4.33-3.52,7.85-7.85,7.85ZM342.64,76.1c-5.62,0-10.2,4.58-10.2,10.2v69.01c0,3.86,3.14,7,7,7h30.51c3.86,0,7-3.14,7-7v-69.01c0-5.62-4.57-10.2-10.2-10.2h-24.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M327.74,57.92h53.92v210.08h1.28V57.27c0-.35-.29-.64-.64-.64h-55.2c-.35,0-.64.29-.64.64v210.72h1.28V57.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M322.18,171.26v11.16c0,2.22-1.8,4.03-4.03,4.03h0c-2.22,0-4.03-1.8-4.03-4.03v-11.16c0-2.22,1.8-4.03,4.03-4.03h0c2.22,0,4.03,1.8,4.03,4.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 311.23,
    y: 175.45,
    width: 13.85,
    height: 3.51,
    transform: "translate(140.95 495.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M319.91,183.69v3.75c0,.97-.79,1.75-1.75,1.75h0c-.97,0-1.75-.79-1.75-1.75v-3.75h3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M316.4,170.72v-3.75c0-.97.79-1.75,1.75-1.75h0c.97,0,1.75.79,1.75,1.75v3.75h-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M312.47,175.94h11.37c.3,0,.55.24.55.55v1.43c0,.3-.24.55-.55.55h-11.37c-.3,0-.55-.24-.55-.55v-1.43c0-.3.24-.55.55-.55Z",
    transform: "translate(140.95 495.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M286.64,136.63h0c-2.89,0-5.23-2.34-5.23-5.23v-43.76c0-2.89,2.34-5.23,5.23-5.23h25.07c2.89,0,5.23,2.34,5.23,5.23v18.69c0,16.74-13.57,30.3-30.3,30.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M342.48,136.63h0c-2.89,0-5.23-2.34-5.23-5.23v-43.76c0-2.89,2.34-5.23,5.23-5.23h25.07c2.89,0,5.23,2.34,5.23,5.23v18.69c0,16.74-13.57,30.3-30.3,30.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M143.57,123.19h-39.37c-11.07,0-18.34-11.58-13.53-21.55,0,0,13.78-36.99,27.28-36.99h57.17c7.45,0,13.49,6.04,13.49,13.49h0c0,24.88-20.17,45.05-45.05,45.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M215.64,123.19h0c-3.54,0-6.42-2.87-6.42-6.42v-45.71c0-3.54,2.87-6.42,6.42-6.42h32.24c3.54,0,6.42,2.87,6.42,6.42v13.47c0,21.35-17.31,38.65-38.65,38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M748.04,64.65h32.24c3.54,0,6.42,2.88,6.42,6.42v13.47c0,21.33-17.32,38.65-38.65,38.65h0c-3.54,0-6.42-2.88-6.42-6.42v-45.71c0-3.54,2.88-6.42,6.42-6.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M452.24,125.65h-49.32v-61.01h139.28v8.63c0,28.93-61.03,52.38-89.95,52.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M622.6,125.65h-49.32v-61.01h139.28v8.63c0,28.93-61.03,52.38-89.95,52.38Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 774.05,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 774.05,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 774.05,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 774.05,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 774.05,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 778.44,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 778.44,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 778.44,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 778.44,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 778.44,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 782.83,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 782.83,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 782.83,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 782.83,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 782.83,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 787.22,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 787.22,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 787.22,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 787.22,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 787.22,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 791.62,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 791.62,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 791.62,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 791.62,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 791.62,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 796.01,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 800.41,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 804.79,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 796.01,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 796.01,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 796.01,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 800.41,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 804.79,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 800.4,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 800.4,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 796.01,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 800.41,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 804.79,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 804.79,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 804.79,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 765.26,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 765.26,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 765.26,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 765.26,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 765.26,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 769.65,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 769.65,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 769.65,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 769.65,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 769.65,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 809.19,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 809.19,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 809.19,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 809.19,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 809.19,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 813.58,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 813.58,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 813.58,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 813.58,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 813.58,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 817.97,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 817.97,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 817.97,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 817.97,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 817.97,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 822.36,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 822.36,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 822.36,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 822.36,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 822.36,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 271.26,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 271.26,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 271.26,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 271.26,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 271.26,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 275.65,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 275.65,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 275.65,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 275.65,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 275.65,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 280.05,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 284.44,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 288.82,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 280.04,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 280.04,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 280.05,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 284.44,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 288.82,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 284.43,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 284.43,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 280.05,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 284.44,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 288.82,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 288.83,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 288.83,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 293.22,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 293.22,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 293.22,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 293.22,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 293.22,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 297.61,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 297.61,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 297.61,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 297.61,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 297.61,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 302,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 302,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 302,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 302,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 302,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 306.4,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 306.4,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 306.4,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 306.4,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 306.4,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 378.55,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 378.55,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 378.55,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 378.55,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 378.55,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 374.15,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 374.15,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 374.15,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 374.15,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 374.15,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 369.76,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 365.37,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 360.98,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 369.76,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 369.76,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 369.76,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 365.37,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 360.98,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 365.37,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 365.37,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 369.76,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 365.37,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 360.98,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 360.98,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 360.98,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 356.58,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 356.58,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 356.58,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 356.58,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 356.58,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 352.19,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 352.19,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 352.19,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 352.19,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 352.19,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 347.8,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 347.8,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 347.8,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 347.8,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 347.8,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 343.41,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 343.41,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 343.41,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 343.41,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 343.41,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 208.43,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 208.43,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 208.43,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 208.43,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 208.43,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 204.04,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 204.04,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 204.04,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 204.04,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 204.04,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 199.65,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.65,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 199.65,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 199.65,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 199.65,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 195.26,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 195.26,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 195.26,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 195.26,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 195.26,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 190.86,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 190.86,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 190.86,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 190.86,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 190.86,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 186.47,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 182.07,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 177.69,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 186.47,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 186.47,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 186.47,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 182.07,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 177.69,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 182.08,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 182.08,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 186.47,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 182.07,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 177.69,
    y: 166.7,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 177.69,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 177.69,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 217.22,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 217.22,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 217.22,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 217.22,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 217.22,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 212.83,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 212.83,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 212.83,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 212.83,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 212.83,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 173.29,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 173.29,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 173.29,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 173.29,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 173.29,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 168.9,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 168.9,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 168.9,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 168.9,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 168.9,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 164.51,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 164.51,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 164.51,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 164.51,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 164.51,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 160.12,
    y: 166.71,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 160.12,
    y: 171.1,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 160.12,
    y: 175.49,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 160.12,
    y: 179.88,
    width: 4.39,
    height: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 160.12,
    y: 184.27,
    width: 4.39,
    height: 4.39
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinibus);
export default __webpack_public_path__ + "static/media/Minibus.9eca60f32d41a78f10260f7d1afed53d.svg";
export { ForwardRef as ReactComponent };